function smoothScrollTo(target) {
  var el = target.startsWith('.') ? document.querySelector(target) : document.getElementById(target);
  if (!el) return;
  var headerH = document.querySelector('.section-header');
  var countsale = document.querySelector('.sale-timer-container');
  var offset = 0;
  if (headerH && getComputedStyle(headerH).position === 'sticky') offset += headerH.offsetHeight;
  if (countsale) {
    var cs = countsale.closest('[id^="shopify-section-"]');
    if (cs && getComputedStyle(cs).position === 'sticky') offset += cs.offsetHeight;
  }
  var top = el.getBoundingClientRect().top + window.scrollY - offset - 20;
  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
}

document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[data-scroll-to]');
  if (trigger) {
    e.preventDefault();
    smoothScrollTo(trigger.dataset.scrollTo);
    return;
  }
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
  var anker = e.target.closest('a[href^="#"]');
  if (!anker || anker.classList.contains('skip-to-content-link')) return;
  var id = decodeURIComponent(anker.getAttribute('href').slice(1));
  if (!id || !document.getElementById(id)) return;
  e.preventDefault();
  smoothScrollTo(id);
});

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';


  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }


  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }


  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {

  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;


    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }


  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }


    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');


    this.drawerOverlay = this.querySelector('.menu-drawer__overlay');
    this.drawerPanel = this.querySelector('.menu-drawer');

    this.bindEvents();
  }

  connectedCallback() {


    if (this.drawerOverlay && this.drawerOverlay.parentNode !== document.body) {
      document.body.appendChild(this.drawerOverlay);
    }
    if (this.drawerPanel && this.drawerPanel.parentNode !== document.body) {
      document.body.appendChild(this.drawerPanel);
    }


    this.addEventListener('keyup', this.onKeyUp.bind(this));
    if (this.drawerPanel) {
      this.drawerPanel.addEventListener('keyup', this.onKeyUp.bind(this));
    }
  }

  bindEvents() {

    const mainSummary = this.mainDetailsToggle.querySelector('summary');
    if (mainSummary) {
      mainSummary.addEventListener('click', this.onSummaryClick.bind(this));
    }


    if (this.drawerPanel) {
      this.drawerPanel.querySelectorAll('summary').forEach((summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
      );


      this.drawerPanel.querySelectorAll(
        'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
      ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }


    if (this.drawerOverlay) {
      this.drawerOverlay.addEventListener('click', () => {
        this.closeMenuDrawer(new Event('click'), this.mainDetailsToggle.querySelector('summary'));
      });
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    if (this.mainDetailsToggle.hasAttribute('open')) {
      const openSubDetails = event.target.closest('details[open]');
      if (openSubDetails && openSubDetails !== this.mainDetailsToggle) {
        this.closeSubmenu(openSubDetails);
      } else {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      }
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 999.98px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      const content = summaryElement.nextElementSibling;
      if (!content || detailsElement.classList.contains('animating')) return;

      event.preventDefault();
      detailsElement.classList.add('animating');

      if (isOpen) {
        detailsElement.classList.add('closing');
        content.style.height = content.scrollHeight + 'px';
        content.offsetHeight;
        content.style.height = '0';
        setTimeout(() => {
          detailsElement.open = false;
          detailsElement.classList.remove('animating', 'closing');
          content.style.height = '';
        }, 270);
      } else {
        detailsElement.open = true;
        content.style.height = '0';
        content.offsetHeight;
        content.style.height = content.scrollHeight + 'px';
        setTimeout(() => {
          detailsElement.classList.remove('animating');
          content.style.height = '';
        }, 270);
      }
    }
  }

  openMenuDrawer(summaryElement) {

    const container = this.drawerPanel || this.mainDetailsToggle;
    container.querySelectorAll('details[open]:not(#Details-menu-drawer-container)').forEach((d) => {
      d.removeAttribute('open');
      d.classList.remove('animating', 'closing');
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', false);
      const c = d.querySelector('.menu-drawer__submenu-content');
      if (c) c.style.height = '';
    });

    summaryElement.setAttribute('aria-expanded', true);
    this.mainDetailsToggle.setAttribute('open', '');

    if (this.drawerOverlay) this.drawerOverlay.removeAttribute('style');
    if (this.drawerPanel) {
      const cssVars = this.drawerPanel.style.cssText.split(';').filter(s => s.trim().startsWith('--')).join(';');
      this.drawerPanel.setAttribute('style', cssVars);
    }

    requestAnimationFrame(() => {
      if (this.drawerOverlay) this.drawerOverlay.classList.add('is-visible');
      if (this.drawerPanel) this.drawerPanel.classList.add('is-visible');
    });

    trapFocus(this.drawerPanel || this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    const panel = this.drawerPanel || this.mainDetailsToggle;
    const navItems = panel.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li');
    const utilityLinks = panel.querySelector('.menu-drawer__utility-links');

    navItems.forEach((item) => {
      item.getAnimations().forEach((a) => a.cancel());
      item.style.opacity = '0';
    });
    if (utilityLinks) {
      utilityLinks.getAnimations().forEach((a) => a.cancel());
      utilityLinks.style.opacity = '0';
    }

    navItems.forEach((item, index) => {
      const anim = item.animate([
        { opacity: 0, transform: 'translateX(-14px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], {
        duration: 260,
        delay: 60 + Math.min(40 * index, 200),
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
      });
      anim.onfinish = () => { item.style.opacity = ''; item.style.transform = ''; };
    });

    if (utilityLinks) {
      const anim = utilityLinks.animate([
        { opacity: 0, transform: 'translateX(-14px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], {
        duration: 260,
        delay: 60 + Math.min(40 * navItems.length, 240),
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
      });
      anim.onfinish = () => { utilityLinks.style.opacity = ''; utilityLinks.style.transform = ''; };
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;


    const container = this.drawerPanel || this.mainDetailsToggle;
    const openDetails = container.querySelectorAll('details[open]:not(#Details-menu-drawer-container)');
    openDetails.forEach((details) => {
      details.classList.add('closing');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', false);
    });

    container.offsetHeight;
    openDetails.forEach((details) => {
      const content = details.querySelector('.menu-drawer__submenu-content');
      if (!content) return;
      content.style.height = content.scrollHeight + 'px';
      content.offsetHeight;
      content.style.height = '0';
      setTimeout(() => {
        details.open = false;
        details.removeAttribute('open');
        details.classList.remove('animating', 'closing');
        content.style.height = '';
      }, 270);
    });


    if (this.drawerOverlay) this.drawerOverlay.classList.remove('is-visible');
    if (this.drawerPanel) this.drawerPanel.classList.remove('is-visible');


    const panel = this.drawerPanel || this.mainDetailsToggle;
    panel.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li').forEach((item) => {
      item.getAnimations().forEach((a) => a.cancel());
      item.style.opacity = '';
      item.style.transform = '';
    });
    const utilityLinks = panel.querySelector('.menu-drawer__utility-links');
    if (utilityLinks) {
      utilityLinks.getAnimations().forEach((a) => a.cancel());
      utilityLinks.style.opacity = '';
      utilityLinks.style.transform = '';
    }

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);


    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        !(this.drawerPanel && this.drawerPanel.contains(document.activeElement))
      ) {
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (!detailsElement) {

      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    } else {
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    detailsElement.removeAttribute('open');
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    super.openMenuDrawer(summaryElement);
    window.addEventListener('resize', this.onResize);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {

        deferredElement.play();
      }


      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {


    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');

    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    if (!currentSlide || !nextSlide) return;

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const direction = button;

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
    // Live-Refresh: bei jedem Cart-Update Section neu fetchen, damit Liquid-Filter
    // (in_cart) das eben hinzugefügte Produkt rauswirft und nächstes nachrückt.
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.loadRecommendations(this.dataset.productId);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        // Antwort immer übernehmen (auch wenn leer → Placeholder verschwindet)
        this.innerHTML = recommendations ? recommendations.innerHTML : '';

        // Wenn keine Produktkarten da sind, ganze Section entfernen
        const hasItems = this.querySelectorAll('li').length > 0;
        if (!hasItems) {
          this.remove();
          return;
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.addEventListener('mouseenter', () => this.open());
      this.addEventListener('mouseleave', () => this.close());
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        e.preventDefault();
      });
    }
  }

  open() {
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
      this.content.classList.remove('is-closing');
      return;
    }
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.content.classList.remove('is-closing');
    this.mainDetailsToggle.setAttribute('open', '');
    if (this.header) this.header.style.setProperty('--mega-hoehe', `${this.content.offsetHeight}px`);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.animateItems();
  }

  animateItems() {
    const items = this.content.querySelectorAll('.mega-menu__column, .mega-menu__image-push');
    items.forEach((item) => {
      item.getAnimations().forEach((a) => a.cancel());
      item.style.opacity = '0';
    });
    items.forEach((item, index) => {
      const anim = item.animate([
        { opacity: 0, transform: 'translateY(20px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], {
        duration: 250,
        delay: 100 + 60 * index,
        easing: 'cubic-bezier(0.65, 0, 0.35, 1)'
      });
      anim.onfinish = () => { item.style.opacity = ''; item.style.transform = ''; };
    });
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    const items = this.content.querySelectorAll('.mega-menu__column, .mega-menu__image-push');
    items.forEach((item) => {
      item.getAnimations().forEach((a) => a.cancel());
      item.style.opacity = '';
      item.style.transform = '';
    });
    this.content.classList.add('is-closing');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this._closeTimeout = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.content.classList.remove('is-closing');
      this._closeTimeout = null;
    }, 250);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {

    event.preventDefault();

    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {

    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {

    return 100;
  }


  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }

      if (event.source === 'product-form' && this.tagName === 'CART-DRAWER-ITEMS') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if (event.target.id === 'cart-upsell-switch') return;
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

    this.enableLoading(line);

    const kylaFeld = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const kylaPlan = kylaAboPlanFuerMenge(kylaFeld, quantity);
    const kylaKey = kylaFeld && kylaFeld.dataset ? kylaFeld.dataset.aboKey : null;
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        if (kylaPlan && kylaKey && !parsedState.errors && window.kylaAboPlanNachziehen) {
          /* Nicht auf parsedState verlassen: legt Easy Gift im selben Schritt Geschenke dazu,
             ist das die Antwort von cart/add.js und enthaelt nur die Geschenkzeilen. Der alte
             Schluessel gilt weiter, weil der Plan bis hierher unveraendert ist. */
          const kylaZeile = (parsedState.items || []).find((i) => i.key === kylaKey);
          if (!kylaZeile || kylaZeile.quantity === quantity) {
            this.enableLoading(line);
            window.kylaAboPlanNachziehen(kylaKey, quantity, kylaPlan)
              .then(() => this.onCartUpdate())
              .then(() => fetch(`${routes.cart_url}.js`).then((r) => r.json()))
              .then((korb) => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: korb, variantId: variantId }))
              .catch((e) => console.error('Abo-Plan nachziehen:', e))
              .finally(() => this.disableLoading(line));
          }
        }
      })
      .catch((e) => {
        console.error('Cart update error:', e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;


    if (window.location.pathname === '/cart') return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);


    if (this.classList.contains('active')) {
      document.body.classList.add('overflow-hidden');
      return;
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);


    this._prepareOpenAnimations();


    setTimeout(() => {
      this.classList.add('animate', 'active');

      this._playOpenAnimations();
    });

    this.addEventListener(
      'transitionend',
      () => {
        // Der Leer-Block steht nur im HTML, wenn der Warenkorb schon beim
        // Seitenaufruf leer war. Wird er erst durch Entfernen leer, ist er
        // nicht da -- und trapFocus warf dann eine Ausnahme, die den
        // transitionend-Handler mitten im Ablauf abbrach.
        const containerToTrapFocusOn =
          (this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : null)
          || document.getElementById('CartDrawer')
          || this;
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  _prepareOpenAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const motivationBanner = this.querySelector('.cart-motivation-banner');
    const shippingBar = this.querySelector('free-shipping-bar');
    const freeItemsBar = this.querySelector('free-items-bar');
    const timerContainer = this.querySelector('.cart-timer-container');
    const lineItems = Array.from(this.querySelectorAll('.cart-drawer__item'));
    const upsell = this.querySelector('.cart-upsell');
    const footer = this.querySelector('.drawer__footer');
    const recommendations = this.querySelector('.cart-drawer__recommendations-inner');


    [motivationBanner, shippingBar, freeItemsBar, timerContainer, ...lineItems, upsell, footer, recommendations].forEach((el) => {
      if (!el) return;
      el.classList.remove('drawer-anim-slide-down', 'drawer-anim-slide-right', 'drawer-anim-slide-up');
      el.style.removeProperty('--anim-delay');
    });

    const isMobile = window.matchMedia('(max-width: 999.98px)').matches;

    if (motivationBanner) motivationBanner.style.opacity = '0';
    if (shippingBar) shippingBar.style.opacity = '0';
    if (freeItemsBar) freeItemsBar.style.opacity = '0';
    if (timerContainer) timerContainer.style.opacity = '0';
    lineItems.forEach((item) => (item.style.opacity = '0'));
    if (upsell) upsell.style.opacity = '0';
    if (footer) footer.style.opacity = '0';

    if (recommendations && isMobile) recommendations.style.opacity = '0';
  }

  _playOpenAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const baseDelay = 40;
    const motivationBanner = this.querySelector('.cart-motivation-banner');
    const shippingBar = this.querySelector('free-shipping-bar');
    const timerContainer = this.querySelector('.cart-timer-container');
    const lineItems = Array.from(this.querySelectorAll('.cart-drawer__item'));
    const upsell = this.querySelector('.cart-upsell');
    const footer = this.querySelector('.drawer__footer');
    const recommendations = this.querySelector('.cart-drawer__recommendations-inner');
    const isMobile = window.matchMedia('(max-width: 999.98px)').matches;


    if (motivationBanner) {
      motivationBanner.style.setProperty('--anim-delay', `${baseDelay - 40}ms`);
      motivationBanner.classList.add('drawer-anim-slide-down');
    }


    if (shippingBar) {
      shippingBar.style.setProperty('--anim-delay', `${baseDelay - 30}ms`);
      shippingBar.classList.add('drawer-anim-slide-down');
    }

    const freeItemsBar = this.querySelector('free-items-bar');
    if (freeItemsBar) {
      freeItemsBar.style.setProperty('--anim-delay', `${baseDelay - 20}ms`);
      freeItemsBar.classList.add('drawer-anim-slide-down');
    }


    if (timerContainer) {
      timerContainer.style.setProperty('--anim-delay', `${baseDelay - 10}ms`);
      timerContainer.classList.add('drawer-anim-slide-down');
    }


    if (upsell) lineItems.push(upsell);


    if (recommendations && isMobile) {
      lineItems.push(recommendations);
    }


    lineItems.forEach((item, index) => {
      const delay = baseDelay + Math.min(35 * index, 175);
      item.style.setProperty('--anim-delay', `${delay}ms`);
      item.classList.add('drawer-anim-slide-right');
    });


    if (footer) {
      footer.style.setProperty('--anim-delay', `${baseDelay}ms`);
      footer.classList.add('drawer-anim-slide-up');
    }



  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this._cleanupAnimations();
  }

  _cleanupAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const elements = [
      this.querySelector('.cart-motivation-banner'),
      this.querySelector('free-shipping-bar'),
      this.querySelector('.cart-timer-container'),
      ...Array.from(this.querySelectorAll('.cart-drawer__item')),
      this.querySelector('.cart-upsell'),
      this.querySelector('.drawer__footer'),
      this.querySelector('.cart-drawer__recommendations-inner'),
    ];
    elements.forEach((el) => {
      if (!el) return;
      el.classList.remove('drawer-anim-slide-down', 'drawer-anim-slide-right', 'drawer-anim-slide-up');
      el.style.removeProperty('--anim-delay');
      el.style.opacity = '';
      el.style.transform = '';
    });


    const recsOuter = this.querySelector('cart-drawer-recommendations');
    if (recsOuter) {
      recsOuter.classList.remove('drawer-anim-slide-right');
      recsOuter.style.removeProperty('--anim-delay');
      recsOuter.style.opacity = '';
      recsOuter.style.transform = '';
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    if (this.classList.contains('active')) {
      if (!document.querySelector('#CartDrawer-Form .js-contents') && parsedState.sections && parsedState.sections['cart-drawer']) {
        const neuerKorb = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        const alterKorb = document.getElementById('CartDrawer');
        if (neuerKorb && alterKorb) {
          alterKorb.innerHTML = neuerKorb.innerHTML;
          this.classList.remove('is-empty');
          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));
        }
      }



      const sectionHTML = parsedState.sections['cart-drawer'];
      if (sectionHTML) {
        const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');

        const newItems = doc.querySelector('.js-contents');
        const curItems = document.querySelector('#CartDrawer-Form .js-contents');
        if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

        const newFooter = doc.querySelector('.drawer__footer');
        const curFooter = document.querySelector('#CartDrawer .drawer__footer');
        if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;

        const newHeading = doc.querySelector('.drawer__heading');
        const curHeading = document.querySelector('#CartDrawer .drawer__heading');
        if (newHeading && curHeading) curHeading.innerHTML = newHeading.innerHTML;
      }

      const bubbleHTML = parsedState.sections['cart-icon-bubble'];
      if (bubbleHTML) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = this.getSectionInnerHTML(bubbleHTML);
      }




      fetch(`${Shopify.routes.root}cart.js`)
        .then((r) => r.json())
        .then((cart) => {

          const shippingBar = this.querySelector('free-shipping-bar');
          if (shippingBar) {
            const totalPrice = (cart.items || [])
              .filter((i) => i.requires_shipping)
              .reduce((sum, i) => sum + i.final_line_price, 0);
            shippingBar.updateBar(totalPrice);
          }



          const recs = this.querySelector('cart-drawer-recommendations');
          if (recs) {
            const cartIds = new Set((cart.items || []).map((i) => i.product_id));
            CartDrawerRecommendations.currentCartProductIds = cartIds;
            recs.querySelectorAll('.cart-drawer__recommendation-card').forEach((card) => {
              if (cartIds.has(parseInt(card.dataset.productId))) card.remove();
            });
            if (!recs.querySelector('.cart-drawer__recommendation-card')) {
              recs.hidden = true;
            }
          }
        })
        .catch(() => {});
      return;
    }

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class DdLeerRaster extends HTMLElement {
  connectedCallback() {
    this.korb = this.closest('cart-drawer');
    if (!this.korb || this.korb.classList.contains('active')) {
      this.zeigen();
      return;
    }
    this.beobachter = new MutationObserver(() => {
      if (this.korb.classList.contains('active')) this.zeigen();
    });
    this.beobachter.observe(this.korb, { attributes: true, attributeFilter: ['class'] });
  }

  disconnectedCallback() {
    this.beobachter?.disconnect();
  }

  zeigen() {
    this.beobachter?.disconnect();
    const vorlage = this.querySelector('template');
    if (vorlage) this.replaceWith(vorlage.content.cloneNode(true));
  }
}

customElements.define('dd-leer-raster', DdLeerRaster);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }


  getSectionInnerHTML(html, selector) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  get lineItemStatusElement() {
    return document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
  }

  set lineItemStatusElement(_) {}


  updateQuantity(line, quantity, event, name, variantId) {
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

    this.enableLoading(line);

    const kylaFeld = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const kylaPlan = kylaAboPlanFuerMenge(kylaFeld, quantity);
    const kylaKey = kylaFeld && kylaFeld.dataset ? kylaFeld.dataset.aboKey : null;
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((r) => r.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);


          const sectionHTML = parsedState.sections['cart-drawer'];
          if (sectionHTML) {
            const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');

            if (parsedState.item_count === 0) {

              const newInner = doc.querySelector('.drawer__inner');
              const curInner = document.querySelector('#CartDrawer .drawer__inner');
              if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
            } else {

              const newItems = doc.querySelector('.js-contents');
              const curItems = document.querySelector('#CartDrawer-Form .js-contents');
              if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

              const newFooter = doc.querySelector('.drawer__footer');
              const curFooter = document.querySelector('#CartDrawer .drawer__footer');
              if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;
            }
          }

          const bubbleHTML = parsedState.sections['cart-icon-bubble'];
          if (bubbleHTML) {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = this.getSectionInnerHTML(bubbleHTML, '.shopify-section');
          }

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            message = typeof updatedValue === 'undefined'
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        if (kylaPlan && kylaKey && !parsedState.errors && window.kylaAboPlanNachziehen) {
          /* Nicht auf parsedState verlassen: legt Easy Gift im selben Schritt Geschenke dazu,
             ist das die Antwort von cart/add.js und enthaelt nur die Geschenkzeilen. Der alte
             Schluessel gilt weiter, weil der Plan bis hierher unveraendert ist. */
          const kylaZeile = (parsedState.items || []).find((i) => i.key === kylaKey);
          if (!kylaZeile || kylaZeile.quantity === quantity) {
            this.enableLoading(line);
            window.kylaAboPlanNachziehen(kylaKey, quantity, kylaPlan)
              .then(() => this.onCartUpdate())
              .then(() => fetch(`${routes.cart_url}.js`).then((r) => r.json()))
              .then((korb) => publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: korb, variantId: variantId }))
              .catch((e) => console.error('Abo-Plan nachziehen:', e))
              .finally(() => this.disableLoading(line));
          }
        }
      })
      .catch((e) => {
        console.error('Cart update error:', e);
        this.querySelectorAll('.loading__spinner').forEach((o) => o.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line, quantity);
        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
      });
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

    const loader = document.getElementById('CartDrawer-Loader');
    const imageWrapper = document.querySelector(`#CartDrawer-Item-${line} .cart-line__media`);

    if (loader && imageWrapper) {
      const rect = imageWrapper.getBoundingClientRect();
      loader.style.top = `${rect.top + rect.height / 2 - 16}px`;
      loader.style.left = `${rect.left + rect.width / 2 - 16}px`;
      loader.querySelector('.cart-loader__spinner').hidden = false;
      loader.querySelector('.cart-loader__mark').hidden = true;
      loader.hidden = false;
    }

    document.activeElement.blur();
    const status = this.lineItemStatusElement;
    if (status) status.setAttribute('aria-hidden', false);
  }

  async disableLoading(line, quantity) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');

    const loader = document.getElementById('CartDrawer-Loader');
    if (!loader || loader.hidden) return;


    if (quantity === 0) {
      loader.hidden = true;
      return;
    }

    const spinner = loader.querySelector('.cart-loader__spinner');
    const mark = loader.querySelector('.cart-loader__mark');


    await new Promise((resolve) => {
      spinner.addEventListener('animationend', resolve, { once: true });
      spinner.classList.add('loader-spinner-out');
    });
    spinner.hidden = true;
    spinner.classList.remove('loader-spinner-out');


    mark.hidden = false;
    mark.classList.add('loader-checkmark-in');
    await new Promise((resolve) => {
      mark.addEventListener('animationend', resolve, { once: true });
    });


    await new Promise((resolve) => setTimeout(resolve, 300));
    mark.classList.remove('loader-checkmark-in');
    loader.hidden = true;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseFloat(this.getAttribute('threshold'));
    subscribe(PUB_SUB_EVENTS.cartUpdate, this._onCartUpdated.bind(this));
  }

  _onCartUpdated(event) {
    if (!event.cartData || !event.cartData.items || typeof event.cartData.item_count !== 'number') return;
    const totalPrice = event.cartData.items
      .filter((item) => item.requires_shipping)
      .reduce((sum, item) => sum + (item.original_line_price ?? item.final_line_price), 0);
    this.updateBar(totalPrice, event.cartData.items);
  }

  updateBar(totalPrice, items) {
    if (!this.threshold) return;
    const aboFrei = this.hasAttribute('data-abo-frei') && Array.isArray(items) && items.some((i) => i.selling_plan_allocation);
    this.style.setProperty('--progress', aboFrei ? 1 : Math.min(totalPrice / this.threshold, 1));

    const textEl = this.querySelector('.cart-shipping-bar__text');
    if (!textEl) return;

    if (aboFrei || totalPrice > this.threshold) {
      textEl.innerHTML = this.getAttribute('data-reached-msg') || '';
    } else {
      const remaining = this.threshold - totalPrice;
      const formatted = this._formatMoney(remaining);
      textEl.innerHTML = (this.getAttribute('data-remaining-msg') || '').replace('[AMOUNT]', formatted);
    }
  }

  _formatMoney(cents) {
    const format = this.getAttribute('money-format') || '{{amount}}';
    const amount = (cents / 100).toFixed(2);
    const amountWithComma = amount.replace('.', ',');
    const amountNoDecimals = Math.round(cents / 100).toString();
    return format
      .replace('{{amount_with_comma_separator}}', amountWithComma.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_with_apostrophe_separator}}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}

class FreeItemsBar extends HTMLElement {
  connectedCallback() {
    this.tiers = JSON.parse(this.getAttribute('data-tiers') || '[]');
    this.tiers.sort((a, b) => a.qty - b.qty);
    const lastTier = this.tiers[this.tiers.length - 1];
    this.barMax = lastTier ? lastTier.qty + lastTier.free : 0;
    this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this._onCartUpdated.bind(this));
  }

  disconnectedCallback() {
    if (this._unsubscribe) this._unsubscribe();
  }

  _onCartUpdated(event) {
    if (!event.cartData || !event.cartData.items || typeof event.cartData.item_count !== 'number') return;
    let totalQty = 0;
    for (const item of event.cartData.items) {
      if (window.upsellVariantId && item.variant_id == window.upsellVariantId) continue;
      totalQty += item.quantity;
    }
    this.setAttribute('data-cart-count', totalQty);
    this._updateBar(totalQty);
  }

  _updateBar(cartCount) {
    if (!this.tiers.length || !this.barMax) return;

    const progress = Math.min(cartCount / this.barMax, 1);
    this.style.setProperty('--fi-progress', progress);

    let nextTier = null;
    let exactMatch = null;
    for (const tier of this.tiers) {
      if (cartCount < tier.qty && !nextTier) nextTier = tier;
      if (cartCount === tier.qty) exactMatch = tier;
    }

    const track = this.querySelector('.cart-free-items-bar__track');
    let textEl = this.querySelector('.cart-free-items-bar__text');
    let msg = '';
    if (exactMatch) {
      const attr = exactMatch.free === 1 ? 'data-reached-one-msg' : 'data-reached-other-msg';
      msg = (this.getAttribute(attr) || '').replace('[FREE_COUNT]', exactMatch.free);
    } else if (nextTier) {
      const remaining = nextTier.qty - cartCount;
      const attr = nextTier.free === 1 ? 'data-remaining-one-msg' : 'data-remaining-other-msg';
      msg = (this.getAttribute(attr) || '')
        .replace('[REMAINING]', remaining)
        .replace('[FREE_COUNT]', nextTier.free);
    } else if (cartCount < this.barMax) {
      const freeRemaining = this.barMax - cartCount;
      const attr = freeRemaining === 1 ? 'data-reached-one-msg' : 'data-reached-other-msg';
      msg = (this.getAttribute(attr) || '').replace('[FREE_COUNT]', freeRemaining);
    } else {
      msg = this.getAttribute('data-congrats-msg') || '';
    }
    if (msg) {
      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'cart-free-items-bar__text';
        track ? this.insertBefore(textEl, track) : this.appendChild(textEl);
      }
      textEl.innerHTML = msg;
    } else if (textEl) {
      textEl.remove();
    }

    this.querySelectorAll('.cart-free-items-bar__milestone').forEach((el) => {
      const tierQty = parseInt(el.getAttribute('data-tier-qty'), 10);
      el.classList.toggle('is-reached', cartCount >= tierQty);
    });
  }
}

if (!customElements.get('free-items-bar')) {
  customElements.define('free-items-bar', FreeItemsBar);
}

class TimerCart extends HTMLElement {
  constructor() {
    super();
    this.timerInterval = null;
    this.cartDrawer = document.querySelector('cart-drawer');
    this.remainingTime = this._getSavedTime() || this._getTimerDuration();
  }

  connectedCallback() {
    this._updateTimerDisplay();
    this._observeCartDrawer();


    if (window.location.pathname.includes('/cart') || (this.cartDrawer && this.cartDrawer.classList.contains('active'))) {
      this._startTimer();
    }
  }

  disconnectedCallback() {
    this._stopTimer();
  }

  _observeCartDrawer() {
    if (!this.cartDrawer) return;


    this._observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (this.cartDrawer.classList.contains('active')) {
            this._startTimer();
          }
        }
      });
    });

    this._observer.observe(this.cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  _getTimerDuration() {
    const container = this.closest('.cart-timer-container');
    if (!container) return 600;
    const duration = parseInt(container.getAttribute('data-timer')) * 60;
    return isNaN(duration) || duration <= 0 ? 600 : duration;
  }

  _getSavedTime() {
    const savedTime = sessionStorage.getItem('cartTimerRemaining');
    return savedTime ? parseInt(savedTime) : null;
  }

  _startTimer() {
    if (this.timerInterval) return;

    this.timerInterval = setInterval(() => {
      if (this.remainingTime <= 0) {
        this._stopTimer();
        this._showExpiredMessage();
      } else {
        this.remainingTime--;
        sessionStorage.setItem('cartTimerRemaining', this.remainingTime);
        this._updateTimerDisplay();
      }
    }, 1000);
  }

  _stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  _updateTimerDisplay() {
    const timeDisplay = this.querySelector('#time-display');
    if (timeDisplay) {
      const minutes = Math.floor(this.remainingTime / 60);
      const seconds = this.remainingTime % 60;
      timeDisplay.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  }

  _showExpiredMessage() {
    const timerText = this.querySelector('#timer');
    const timerEndMessage = this.querySelector('#timer-end');

    if (timerText && timerEndMessage) {
      timerText.style.display = 'none';
      timerEndMessage.style.display = 'block';
    }
  }
}

if (!customElements.get('timer-cart')) {
  customElements.define('timer-cart', TimerCart);
}

class CartDrawerRecommendations extends HTMLElement {
  static recommendationsCache = {};
  static currentCartProductIds = new Set();

  connectedCallback() {
    this._animateNextShow = true;
    this._fetchCartAndLoad();

    this._cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event.cartData) return;
      if (event.source === 'product-form' || event.source === 'bundle-form') return;

      const items = event.cartData.items;
      if (!items) return;

      CartDrawerRecommendations.currentCartProductIds = new Set(items.map((item) => item.product_id));

      const firstItem = items[0];
      const newProductId = firstItem ? String(firstItem.product_id) : '';
      if (newProductId && newProductId !== this.getAttribute('product-id')) {
        this.setAttribute('product-id', newProductId);
        delete CartDrawerRecommendations.recommendationsCache[this._lastLoadedProductId];
      }

      this._loadRecommendations();
    });

    this._observeDrawerOpen();
  }

  disconnectedCallback() {
    if (this._cartUpdateUnsub) this._cartUpdateUnsub();
    if (this._drawerObserver) this._drawerObserver.disconnect();
  }

  async _fetchCartAndLoad() {
    try {
      const response = await fetch(`${Shopify.routes.root}cart.js`);
      const cart = await response.json();
      CartDrawerRecommendations.currentCartProductIds = new Set(
        (cart.items || []).map((item) => item.product_id)
      );
    } catch (e) {}
    this._loadRecommendations();
  }

  _observeDrawerOpen() {
    const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
    if (!drawer) return;

    let wasActive = drawer.classList.contains('active');
    this._drawerObserver = new MutationObserver(() => {
      const isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        this._animateNextShow = true;
        this._loadRecommendations();
      }
      wasActive = isActive;
    });
    this._drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  async _loadRecommendations() {
    if (this._slidingOut) return;

    const productId = this.getAttribute('product-id');
    if (!productId || productId === 'null' || productId === '') return;

    this._lastLoadedProductId = productId;

    try {
      if (!CartDrawerRecommendations.recommendationsCache[productId]) {
        const baseUrl = this.dataset.url || `${Shopify.routes.root}recommendations/products?limit=16&section_id=cart-drawer-recommendations`;
        const sectionUrl = `${baseUrl}&product_id=${productId}`;
        const jsonUrl = `${Shopify.routes.root}recommendations/products.json?limit=16&product_id=${productId}`;
        CartDrawerRecommendations.recommendationsCache[productId] = Promise.all([
          fetch(sectionUrl).then((r) => r.text()),
          fetch(jsonUrl).then((r) => r.json())
        ]).then(([html, json]) => {
          const allowedIds = new Set((json.products || []).map((p) => String(p.id)));
          return { html, allowedIds };
        });
      }

      const { html, allowedIds } = await CartDrawerRecommendations.recommendationsCache[productId];
      this._renderFromHTML(html, allowedIds);
    } catch (e) {
      delete CartDrawerRecommendations.recommendationsCache[productId];
      this.hidden = true;
    }
  }

  _renderFromHTML(html, allowedIds) {
    const list = this.querySelector('.cart-drawer__recommendations-list');
    if (!list) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    let cards = [...doc.querySelectorAll('.cart-drawer__recommendation-card')];

    if (allowedIds) {
      cards = cards.filter((card) => allowedIds.has(card.dataset.productId));
    }

    if (!cards.length) {
      this._slideOut();
      return;
    }

    const cartProductIds = CartDrawerRecommendations.currentCartProductIds;
    const filteredCards = cards.filter((card) => {
      const pid = parseInt(card.dataset.productId);
      return !cartProductIds.has(pid);
    });

    const displayCards = filteredCards.slice(0, 8);

    if (displayCards.length === 0) {
      this._slideOut();
      return;
    }

    const wasHidden = this.hidden;
    list.innerHTML = '';
    displayCards.forEach((card) => list.appendChild(card));

    if (wasHidden && this._animateNextShow) {
      this._animateNextShow = false;
      const isDesktop = window.matchMedia('(min-width: 1000px)').matches;

      if (isDesktop) {
        const inner = this.querySelector('.cart-drawer__recommendations-inner');
        if (inner) {
          inner.style.opacity = '';
          inner.style.transform = '';
          inner.classList.remove('drawer-anim-slide-right');
          inner.style.removeProperty('--anim-delay');
        }
        this.style.transform = 'translateX(100%)';
        this.style.opacity = '0';
        this.hidden = false;
        void this.offsetHeight;
        this.style.transform = '';
        this.style.opacity = '';
      } else {
        this.style.opacity = '0';
        this.hidden = false;
        requestAnimationFrame(() => {
          const inner = this.querySelector('.cart-drawer__recommendations-inner');
          if (inner) {
            inner.style.opacity = '';
            inner.style.transform = '';
            inner.classList.remove('drawer-anim-slide-right');
            inner.style.removeProperty('--anim-delay');
          }
          this.style.opacity = '';
          this.style.setProperty('--anim-delay', '0ms');
          this.classList.add('drawer-anim-slide-right');
          this.addEventListener('animationend', () => {
            this.classList.remove('drawer-anim-slide-right');
            this.style.removeProperty('--anim-delay');
          }, { once: true });
        });
      }
    } else if (wasHidden) {
      this.hidden = false;
    } else {
      this.hidden = false;
    }
  }

  _slideOut() {
    if (this.hidden || this._slidingOut) return;
    this._slidingOut = true;
    this.classList.add('is-sliding-out');
    this.addEventListener('animationend', () => {
      this.hidden = true;
      this._slidingOut = false;
      this.classList.remove('is-sliding-out');
      const list = this.querySelector('.cart-drawer__recommendations-list');
      if (list) list.innerHTML = '';
    }, { once: true });
  }

  _showLineItemCheckmark(variantId) {
    const loader = document.getElementById('CartDrawer-Loader');
    if (!loader) return;

    const variantEl = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (!variantEl) return;
    const lineItem = variantEl.closest('.cart-drawer__item');
    if (!lineItem) return;

    const imageWrapper = lineItem.querySelector('.cart-line__media');
    if (!imageWrapper) return;

    const rect = imageWrapper.getBoundingClientRect();
    loader.style.top = `${rect.top + rect.height / 2 - 16}px`;
    loader.style.left = `${rect.left + rect.width / 2 - 16}px`;

    const loaderSpinner = loader.querySelector('.cart-loader__spinner');
    const mark = loader.querySelector('.cart-loader__mark');

    loaderSpinner.hidden = true;
    mark.hidden = false;
    loader.hidden = false;

    mark.classList.add('cart-loader-checkmark');
    mark.addEventListener('animationend', () => {
      setTimeout(() => {
        mark.classList.remove('cart-loader-checkmark');
        loader.hidden = true;
      }, 400);
    }, { once: true });
  }
}

if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}

/* ============================================================
   Zipify-compatible upsell: Add upsell product before Zipify checkout
   ============================================================ */
(function() {
  var origFetch = window.fetch;
  var upsellAdded = false;

  window.fetch = function() {
    var url = arguments[0];

    if (typeof url === 'string' && (url.includes('ocu.zipify.com') || url.includes('/apps/oneclickupsell/pre_purchase/')) && !upsellAdded) {
      var checkbox = document.querySelector('#cart-upsell-switch');
      var form = document.querySelector('form.priority-processing');
      if (checkbox && checkbox.checked && form) {
        var variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          upsellAdded = true;
          var origArgs = arguments;
          var origThis = this;
          return origFetch.call(this, Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantInput.value), quantity: 1 })
          }).then(function() {
            return origFetch.apply(origThis, origArgs);
          }).catch(function() {
            return origFetch.apply(origThis, origArgs);
          });
        }
      }
    }

    return origFetch.apply(this, arguments);
  };

  window.addEventListener('pageshow', function() { upsellAdded = false; });
})();

(function () {
  let isProcessing = false;

  function removeUpsellProductFromCart() {
    const form = document.querySelector('form.priority-processing');
    if (!form) return;
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    const variantId = variantInput.value;

    fetch(`${Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const itemInCart = cart.items.find((item) => item.id == variantId);
        if (!itemInCart) return;

        fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 }),
        });
      });
  }

  function addUpsellProductToCart(callback) {
    const form = document.querySelector('form.priority-processing');
    if (!form) {
      isProcessing = false;
      return;
    }
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) {
      isProcessing = false;
      return;
    }

    fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: parseInt(variantInput.value),
        quantity: 1,
      }),
    })
      .then((response) => {
        if (response.ok && callback) callback();
        else isProcessing = false;
      })
      .catch(() => {
        isProcessing = false;
      });
  }


  document.addEventListener('click', function (event) {
    const upsellBtn = event.target.closest('#CartDrawer-UpsellCheckout');
    if (!upsellBtn) return;

    event.preventDefault();
    if (isProcessing) return;

    const checkbox = document.querySelector('#cart-upsell-switch');
    if (checkbox && checkbox.checked) {
      isProcessing = true;
      addUpsellProductToCart(function () {
        isProcessing = false;
        const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
        if (checkoutBtn) checkoutBtn.click();
      });
    } else {
      const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
      if (checkoutBtn) checkoutBtn.click();
    }
  });


  window.addEventListener('pageshow', function () {
    removeUpsellProductFromCart();
    isProcessing = false;
  });
})();

(function () {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    const cartIconBubble = document.querySelector('#cart-icon-bubble');
    if (!cartIconBubble) return;

    const cartData = event.cartData;
    if (!cartData) return;

    let itemCount = cartData.item_count;


    if (window.upsellVariantId && cartData.items) {
      const upsellItem = cartData.items.find((item) => item.variant_id == window.upsellVariantId);
      if (upsellItem) {
        itemCount -= upsellItem.quantity;
      }
    }

    const existingPing = cartIconBubble.querySelector('.cart-ping-animation');

    if (itemCount > 0) {
      if (!existingPing) {
        const ping = document.createElement('span');
        ping.className = 'cart-ping-animation';
        const countBubble = cartIconBubble.querySelector('.cart-count-bubble');
        if (countBubble) {
          countBubble.appendChild(ping);
        }
      }
    } else {
      if (existingPing) {
        existingPing.remove();
      }
    }
  });
})();

class FilterPanel extends HTMLElement {
  connectedCallback() {
    this._onFilterChange = this._onFilterChange.bind(this);
    this._onCloseClick = this._onCloseClick.bind(this);
    this._onOverlayClick = this._onOverlayClick.bind(this);


    this.addEventListener('change', (e) => {
      if (e.target.name && e.target.name.startsWith('filter.')) {
        if (this._isDrawerMode()) return;
        this._onFilterChange();
      }
    });


    document.addEventListener('click', (e) => {
      const clearLink = e.target.closest('[data-action="clear-filters"]');
      if (clearLink) {
        e.preventDefault();
        this.dispatchEvent(new CustomEvent('filter:changed', { bubbles: true, detail: { url: clearLink.href } }));
      }
    });


    this.querySelectorAll('[data-action="close"]').forEach((btn) => {
      btn.addEventListener('click', this._onCloseClick);
    });


    this.querySelectorAll('[data-action="apply"]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this._onFilterChange();
        this.close();
      });
    });


    const overlay = this.querySelector('.collection-filters__overlay');
    if (overlay) overlay.addEventListener('click', this._onOverlayClick);


    if (this.hasAttribute('always-visible')) {
      this._mq = window.matchMedia('(max-width: 999.98px)');
      this._onBreakpointChange = this._onBreakpointChange.bind(this);
      this._mq.addEventListener('change', this._onBreakpointChange);
      this._onBreakpointChange(this._mq);
    }
  }

  get isOpen() {
    return this.hasAttribute('open');
  }

  open() {
    this.setAttribute('open', '');
    document.documentElement.classList.add('filters-drawer-open');
  }

  close() {
    this.removeAttribute('open');
    document.documentElement.classList.remove('filters-drawer-open');
  }

  _isDrawerMode() {
    return this.classList.contains('collection-filters__panel--drawer') || this.classList.contains('is-drawer-mobile');
  }

  _onCloseClick() {
    this.close();
  }

  _onOverlayClick() {
    this.close();
  }

  _onFilterChange() {
    const form = this.querySelector('#filter-form');
    if (!form) return;
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    this.dispatchEvent(
      new CustomEvent('filter:changed', { bubbles: true, detail: { url: `${window.location.pathname}?${searchParams}` } })
    );
  }

  _onBreakpointChange(e) {
    const isMobile = e.matches !== undefined ? e.matches : e;
    this.classList.toggle('is-drawer-mobile', isMobile);
    this.classList.toggle('collection-filters__panel--drawer', isMobile);
    if (!isMobile && this.isOpen) {
      this.close();
    }
  }
}
customElements.define('filter-panel', FilterPanel);

class FilterPriceRange extends HTMLElement {
  connectedCallback() {
    this.rangeLow = this.querySelector('.filter-price-range__sliders input:first-child');
    this.rangeHigh = this.querySelector('.filter-price-range__sliders input:last-child');
    this.inputLow = this.querySelector('.filter-price-range__field:first-child input');
    this.inputHigh = this.querySelector('.filter-price-range__field:last-child input');

    if (!this.rangeLow || !this.rangeHigh || !this.inputLow || !this.inputHigh) return;


    this.inputLow.addEventListener('focus', () => this.inputLow.select());
    this.inputHigh.addEventListener('focus', () => this.inputHigh.select());


    this.inputLow.addEventListener('change', (e) => {
      e.target.value = Math.max(
        Math.min(parseInt(e.target.value) || 0, parseInt(this.inputHigh.value || e.target.max) - 1),
        parseInt(e.target.min) || 0
      );
      this.rangeLow.value = e.target.value;
      this._updateTrack();
    });

    this.inputHigh.addEventListener('change', (e) => {
      e.target.value = Math.min(
        Math.max(parseInt(e.target.value) || 0, parseInt(this.inputLow.value || e.target.min) + 1),
        parseInt(e.target.max)
      );
      this.rangeHigh.value = e.target.value;
      this._updateTrack();
    });


    this.rangeLow.addEventListener('change', (e) => {
      this.inputLow.value = e.target.value;
      this.inputLow.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.rangeHigh.addEventListener('change', (e) => {
      this.inputHigh.value = e.target.value;
      this.inputHigh.dispatchEvent(new Event('change', { bubbles: true }));
    });


    this.rangeLow.addEventListener('input', (e) => {
      this.dispatchEvent(new CustomEvent('filter:abort', { bubbles: true }));
      e.target.value = Math.min(parseInt(e.target.value), parseInt(this.inputHigh.value || e.target.max) - 1);
      this.inputLow.value = e.target.value;
      this._updateTrack();
    });

    this.rangeHigh.addEventListener('input', (e) => {
      this.dispatchEvent(new CustomEvent('filter:abort', { bubbles: true }));
      e.target.value = Math.max(parseInt(e.target.value), parseInt(this.inputLow.value || e.target.min) + 1);
      this.inputHigh.value = e.target.value;
      this._updateTrack();
    });
  }

  _updateTrack() {
    const sliders = this.querySelector('.filter-price-range__sliders');
    if (!sliders) return;
    const max = parseInt(this.rangeLow.max);
    sliders.style.setProperty('--range-min', `${(parseInt(this.rangeLow.value) / max) * 100}%`);
    sliders.style.setProperty('--range-max', `${(parseInt(this.rangeHigh.value) / max) * 100}%`);
  }
}
customElements.define('filter-price-range', FilterPriceRange);

class SortByDropdown extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  connectedCallback() {

    this.addEventListener('change', (e) => {
      if (e.target.name !== 'sort_by') return;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');


      const valueEl = document.getElementById('sort-by-value');
      if (valueEl) valueEl.textContent = e.target.title || e.target.closest('label')?.querySelector('.sort-popover__choice-label')?.textContent || e.target.value;

      this.open = false;
      this.dispatchEvent(
        new CustomEvent('filter:changed', { bubbles: true, detail: { url: url.toString() } })
      );
    });


    this.querySelectorAll('[data-action="close"]').forEach((btn) => {
      btn.addEventListener('click', () => (this.open = false));
    });

    const overlay = this.querySelector('.sort-popover__overlay');
    if (overlay) overlay.addEventListener('click', () => (this.open = false));


    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.open = false;
    });


    document.addEventListener('click', (e) => {
      if (!this.open) return;
      if (this.contains(e.target)) return;
      if (e.target.closest(`[aria-controls="${this.id}"]`)) return;
      this.open = false;
    });
  }

  get open() {
    return this.hasAttribute('open');
  }

  set open(val) {
    if (val) this.setAttribute('open', '');
    else this.removeAttribute('open');
  }

  attributeChangedCallback(name) {
    if (name === 'open') {

      if (window.matchMedia('(max-width: 999.98px)').matches) {
        document.documentElement.classList.toggle('filters-drawer-open', this.open);
      }

      document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((btn) => {
        btn.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      });
    }
  }
}
customElements.define('sort-by-dropdown', SortByDropdown);

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[aria-controls^="sort-popover"]');
  if (!btn) return;
  const popover = document.getElementById(btn.getAttribute('aria-controls'));
  if (popover && popover.tagName === 'SORT-BY-DROPDOWN') {
    popover.open = !popover.open;
  }
});

class CollectionFilterForm extends HTMLElement {
  connectedCallback() {
    this._onFilterChanged = this._onFilterChanged.bind(this);
    this._onAbort = this._onAbort.bind(this);

    this.addEventListener('filter:changed', this._onFilterChanged);
    this.addEventListener('filter:abort', this._onAbort);


    this.addEventListener('click', (e) => {
      const pageLink = e.target.closest('.pagination a[data-page], .pagination a[href]');
      if (!pageLink) return;
      e.preventDefault();

      let url;
      if (pageLink.dataset.page) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('page', pageLink.dataset.page);
        url = currentUrl.toString();
      } else {
        url = pageLink.href;
      }

      this.dispatchEvent(new CustomEvent('filter:changed', { bubbles: true, detail: { url } }));
    });


    this._onPopState = this._onPopState.bind(this);
    window.addEventListener('popstate', this._onPopState);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this._onPopState);
  }

  _onPopState() {
    this._rerender(window.location.href, false);
  }

  async _onFilterChanged(e) {
    e.stopPropagation();
    const url = e.detail?.url;
    if (!url) return;
    await this._rerender(url, true);
  }

  async _rerender(url, pushState = true) {

    this._onAbort();


    this.classList.add('is-loading');


    if (pushState) {
      history.replaceState({}, '', url);
    }

    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', this.getAttribute('section-id'));

    try {
      this.abortController = new AbortController();
      const response = await fetch(fetchUrl.toString(), { signal: this.abortController.signal });
      const html = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;


      const newMain = tempDiv.querySelector('#filter-main');
      const currentMain = this.querySelector('#filter-main');
      if (newMain && currentMain) {
        currentMain.innerHTML = newMain.innerHTML;
      }


      const newPanel = tempDiv.querySelector('#filter-panel');
      const currentPanel = this.querySelector('#filter-panel');
      if (newPanel && currentPanel) {
        const scrollContainer = currentPanel.querySelector('.collection-filters__panel-content');
        const previousScroll = scrollContainer ? scrollContainer.scrollTop : 0;


        const currentDetails = currentPanel.querySelectorAll('details[data-filter]');
        currentDetails.forEach((detail) => {
          const filterKey = detail.getAttribute('data-filter');
          const isOpen = detail.open;
          const newDetail = newPanel.querySelector(`details[data-filter="${filterKey}"]`);
          if (newDetail) {
            if (isOpen) {
              newDetail.setAttribute('open', '');
            } else {
              newDetail.removeAttribute('open');
            }
          }
        });

        const badgeRows = currentPanel.querySelectorAll('.filter-badges-row__track');
        const badgeScrollMap = new Map();
        badgeRows.forEach((row) => {
          const key = row.closest('[data-filter]')?.dataset.filter;
          if (key) badgeScrollMap.set(key, row.scrollLeft);
        });

        currentPanel.innerHTML = newPanel.innerHTML;


        const newScrollContainer = currentPanel.querySelector('.collection-filters__panel-content');
        if (newScrollContainer) {
          newScrollContainer.scrollTop = previousScroll;
        }

        currentPanel.querySelectorAll('.filter-badges-row__track').forEach((row) => {
          const key = row.closest('[data-filter]')?.dataset.filter;
          if (key && badgeScrollMap.has(key)) {
            row.scrollLeft = badgeScrollMap.get(key);
          }
        });


        currentPanel.querySelectorAll('[data-action="close"]').forEach((btn) => {
          btn.addEventListener('click', () => currentPanel.close?.());
        });
        currentPanel.querySelectorAll('[data-action="apply"]').forEach((btn) => {
          btn.addEventListener('click', () => {
            currentPanel._onFilterChange?.();
            currentPanel.close?.();
          });
        });
        const overlay = currentPanel.querySelector('.collection-filters__overlay');
        if (overlay) overlay.addEventListener('click', () => currentPanel.close?.());
      }


      const panel = this.querySelector('#filter-panel');
      const isBadges = panel && panel.hasAttribute('badges-mode');
      if (!isBadges) {
        const scrollTarget =
          this.querySelector('.collection-filters__meta-bar') ||
          this.querySelector('.collection-filters__product-list') ||
          this.querySelector('.collection-filters__main');
        if (scrollTarget) {
          requestAnimationFrame(() => {
            scrollTarget.scrollIntoView({ block: 'start', behavior: 'smooth' });
          });
        }
      }

      this.classList.remove('is-loading');
    } catch (err) {
      if (err.name === 'AbortError') return;
      this.classList.remove('is-loading');
    }
  }

  _onAbort() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }
}
customElements.define('collection-filter-form', CollectionFilterForm);

class FilterTagRemove extends HTMLElement {
  connectedCallback() {
    const link = this.querySelector('a');
    if (!link) return;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      this.dispatchEvent(
        new CustomEvent('filter:changed', { bubbles: true, detail: { url: link.href } })
      );
    });
  }
}
customElements.define('filter-tag-remove', FilterTagRemove);

class ComboBox extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('[role="option"]'));
    this.overlay = this.querySelector('.combo-box__overlay');
    this.closeBtn = this.querySelector('[data-action="close"]');


    this.addEventListener('click', (e) => {
      const option = e.target.closest('[role="option"]');
      if (option) this._onOptionClick(option);
    });


    if (this.overlay) {
      this.overlay.addEventListener('click', () => { this.open = false; });
    }


    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.open = false;
      });
    }


    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (e.key === 'ArrowDown') {
          document.activeElement.nextElementSibling?.focus();
        } else {
          document.activeElement.previousElementSibling?.focus();
        }
      }
      if (e.key === 'Escape') {
        this.open = false;
      }
    });


    const select = this.querySelector('select');
    if (select) {
      select.addEventListener('change', (e) => {
        this.selectedValue = e.target.value;
      });
    }
  }

  get nativeControl() {
    return this.querySelector('input[type="hidden"]') || this.querySelector('select');
  }

  get open() {
    return this.hasAttribute('open');
  }

  set open(value) {
    if (value) {
      this.setAttribute('open', '');
    } else {
      this.removeAttribute('open');
    }
  }

  set selectedValue(value) {
    this.options.forEach((option) => {
      option.setAttribute('aria-selected', option.getAttribute('value') === value ? 'true' : 'false');
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'open') return;

    const insideDrawer = !!this.closest('product-drawer');

    if (this.open) {

      const rect = this.getBoundingClientRect();
      this.classList.toggle('combo-box--top', rect.top >= window.innerHeight / 2 * 1.5);
      if (!insideDrawer) document.documentElement.classList.add('lock-mobile');


      setTimeout(() => {
        this._outsideClickHandler = (e) => {
          if (!this.contains(e.target) && !this._toggleButton?.contains(e.target)) {
            this.open = false;
          }
        };
        document.addEventListener('click', this._outsideClickHandler);
      }, 0);
    } else {
      if (!insideDrawer) document.documentElement.classList.remove('lock-mobile');
      this.classList.remove('combo-box--top');
      if (this._outsideClickHandler) {
        document.removeEventListener('click', this._outsideClickHandler);
        this._outsideClickHandler = null;
      }


      if (this._toggleButton) {
        this._toggleButton.setAttribute('aria-expanded', 'false');
      }
    }
  }

  get _toggleButton() {
    return this.id ? document.querySelector(`[aria-controls="${this.id}"]`) : null;
  }

  _onOptionClick(target) {
    const newValue = target.getAttribute('value');
    this.selectedValue = newValue;
    const nativeControl = this.nativeControl;
    if (nativeControl && nativeControl.value !== newValue) {
      nativeControl.value = newValue;

      if (nativeControl.dataset.optionValueId !== undefined) {
        nativeControl.dataset.optionValueId = newValue;
      }
      nativeControl.dispatchEvent(new Event('change', { bubbles: true }));
    }


    const toggleBtn = this._toggleButton;
    if (toggleBtn) {
      const display = toggleBtn.querySelector('.select__selected-value');
      if (display) {

        const existingSwatch = display.querySelector('.select__color-swatch');
        const targetSwatch = target.querySelector('.combo-box__color-swatch');

        if (existingSwatch && targetSwatch) {
          existingSwatch.style.cssText = targetSwatch.style.cssText;

          existingSwatch.classList.toggle(
            'select__color-swatch--white',
            targetSwatch.classList.contains('combo-box__color-swatch--white')
          );

          const textNode = Array.from(display.childNodes).find((n) => n.nodeType === Node.TEXT_NODE);
          if (textNode) {
            textNode.textContent = target.textContent.trim();
          }
        } else {
          display.textContent = target.textContent.trim();
        }
      }
    }

    this.open = false;
  }
}

if (!customElements.get('combo-box')) {
  customElements.define('combo-box', ComboBox);
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[aria-controls^="combo-box-"]');
  if (!btn) return;

  const comboBox = document.getElementById(btn.getAttribute('aria-controls'));
  if (!comboBox) return;

  e.preventDefault();
  const isExpanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
  comboBox.open = !isExpanded;
});

document.addEventListener('click', (e) => {
  const summary = e.target.closest('.accordion summary');
  if (!summary) return;

  e.preventDefault();

  const details = summary.closest('details');
  if (details.classList.contains('animating')) return;
  const content = details.querySelector(':scope > *:not(summary)');
  details.classList.add('animating');

  let done = false;

  function cleanup() {
    if (done) return;
    done = true;
    clearTimeout(fallback);
    content.removeEventListener('transitionend', onEnd);
    if (details.classList.contains('closing')) {
      details.open = false;
      details.classList.remove('closing');
    }
    details.classList.remove('animating');
    content.style.height = '';
  }

  function onEnd(evt) {
    if (evt.target === content && evt.propertyName === 'height') cleanup();
  }

  content.addEventListener('transitionend', onEnd);
  const fallback = setTimeout(cleanup, 450);

  if (details.open) {
    details.classList.add('closing');
    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight;
    content.style.height = '0';
  } else {
    details.open = true;
    content.style.height = '0';
    content.offsetHeight;
    content.style.height = content.scrollHeight + 'px';
  }
});

const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {

      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;

        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {

    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );


    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);

      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];

          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ========== END: facets.js ========== */

/* ========== FILE: localization-form.js ========== */
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

/* ========== END: localization-form.js ========== */

/* ========== FILE: magnify.js ========== */
// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);

/* ========== END: magnify.js ========== */

/* ========== FILE: main-cart.js ========== */
/**
 * Cart Page Custom Elements for Dawn
 * Defines: safe-sticky, line-item-quantity, collapsible-content (cart page),
 * shipping-estimator, country-selector, cart-page-note, input-number
 */

/* ============================================================
   safe-sticky — Sticky sidebar with smart scroll behavior
   ============================================================ */
if (!customElements.get('safe-sticky')) {
  class SafeSticky extends HTMLElement {
    connectedCallback() {
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.hasPendingRaf = false;
      this._onScroll = this._checkPosition.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
    }

    get initialTopOffset() {
      const styles = getComputedStyle(document.documentElement);
      const headerHeight = parseInt(styles.getPropertyValue('--header-height') || '0');
      const stickyHeader = parseInt(styles.getPropertyValue('--enable-sticky-header') || '0');
      const offset = parseInt(this.getAttribute('offset')) || 0;
      return (headerHeight * stickyHeader) + offset;
    }

    _checkPosition() {
      if (this.hasPendingRaf) return;
      this.hasPendingRaf = true;

      requestAnimationFrame(() => {
        const bounds = this.getBoundingClientRect();
        const maxTop = bounds.top + window.scrollY - this.offsetTop + this.initialTopOffset;
        const minTop = this.clientHeight - window.innerHeight;

        if (window.scrollY < this.lastKnownY) {
          this.currentTop -= window.scrollY - this.lastKnownY;
        } else {
          this.currentTop += this.lastKnownY - window.scrollY;
        }

        this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTopOffset);
        this.lastKnownY = window.scrollY;
        this.style.top = `${this.currentTop}px`;
        this.hasPendingRaf = false;
      });
    }
  }
  customElements.define('safe-sticky', SafeSticky);
}

/* ============================================================
   line-item-quantity — Quantity +/- and input for cart line items
   On the cart page, changes trigger a page reload via URL navigation
   ============================================================ */
if (!customElements.get('line-item-quantity')) {
  class LineItemQuantity extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', this._onLinkClicked.bind(this));
      });
      this.querySelectorAll('input').forEach(input => {
        input.addEventListener('change', this._onInputChanged.bind(this));
      });
    }

    _onLinkClicked(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const href = target.getAttribute('data-change') || target.href;
      if (!href) return;
      const input = this.querySelector('input[name="updates[]"]');
      const mengeTreffer = /[?&]quantity=(\d+)/.exec(href);
      const zeileTreffer = /[?&]line=(\d+)/.exec(href);
      const plan = input && mengeTreffer && zeileTreffer ? kylaAboPlanFuerMenge(input, mengeTreffer[1]) : null;
      if (plan) {
        kylaAboPlanWechseln(parseInt(zeileTreffer[1], 10), parseInt(mengeTreffer[1], 10), plan, href);
        return;
      }
      window.location.href = href;
    }

    _onInputChanged(event) {
      const input = event.currentTarget;
      const quantity = input.value;
      const line = input.getAttribute('data-line');
      const href = `${window.routes.cart_change_url}?quantity=${quantity}&line=${line}`;
      const plan = kylaAboPlanFuerMenge(input, quantity);
      if (plan) {
        kylaAboPlanWechseln(parseInt(line, 10), parseInt(quantity, 10), plan, href);
        return;
      }
      window.location.href = href;
    }
  }
  customElements.define('line-item-quantity', LineItemQuantity);
}

/* ============================================================
   cart-page-collapsible — Simple collapsible content
   ============================================================ */
if (!customElements.get('cart-page-collapsible')) {
  class CartPageCollapsible extends HTMLElement {
    static get observedAttributes() {
      return ['open'];
    }

    constructor() {
      super();
      this._ignoreFirst = this.hasAttribute('open');
    }

    get open() {
      return this.hasAttribute('open');
    }

    set open(value) {
      if (value) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }
    }

    attributeChangedCallback(name) {
      if (this._ignoreFirst) {
        this._ignoreFirst = false;
        return;
      }
      if (name === 'open') {
        this.style.overflow = 'hidden';
        this.animate(
          {
            height: ['0px', `${this.scrollHeight}px`],
            visibility: ['hidden', 'visible']
          },
          {
            duration: 400,
            direction: this.open ? 'normal' : 'reverse',
            easing: 'cubic-bezier(0.75, 0, 0.175, 1)'
          }
        ).onfinish = () => {
          this.style.overflow = this.open ? 'visible' : 'hidden';
        };
      }
    }
  }
  customElements.define('cart-page-collapsible', CartPageCollapsible);
}

/* ============================================================
   Toggle button for collapsible elements
   ============================================================ */
document.addEventListener('click', function(event) {
  const toggleBtn = event.target.closest('[data-toggle-collapsible]');
  if (!toggleBtn) return;

  const targetId = toggleBtn.getAttribute('aria-controls');
  const target = document.getElementById(targetId);
  if (!target) return;

  const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
  toggleBtn.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
  target.open = !isExpanded;
});

/* ============================================================
   input-number — Numeric input with min/max clamping
   ============================================================ */
if (!customElements.get('input-number')) {
  class InputNumber extends HTMLInputElement {
    connectedCallback() {
      this.addEventListener('input', this._onInput.bind(this));
      this.addEventListener('change', this._onChange.bind(this));
    }

    get quantity() {
      return parseInt(this.value);
    }

    set quantity(val) {
      if (val === '') return;
      const num = parseInt(val);
      if (isNaN(num) || num < 0) {
        this.value = (this.min || 1).toString();
        return;
      }
      const min = parseInt(this.min) || 1;
      const max = parseInt(this.max) || Number.MAX_VALUE;
      this.value = Math.max(min, Math.min(num, max)).toString();
    }

    _onInput() {
      this.quantity = this.value;
    }

    _onChange() {
      if (this.value === '') {
        this.quantity = this.min || 1;
      }
    }
  }
  customElements.define('input-number', InputNumber, { extends: 'input' });
}

/* ============================================================
   country-selector — Country dropdown with province auto-fill
   ============================================================ */
if (!customElements.get('country-selector')) {
  class CountrySelector extends HTMLSelectElement {
    connectedCallback() {
      this.provinceWrapper = document.getElementById(this.getAttribute('aria-owns'));
      this.addEventListener('change', this._updateProvinces.bind(this));

      if (this.hasAttribute('data-default')) {
        const defaultCountry = this.getAttribute('data-default');
        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].text === defaultCountry) {
            this.selectedIndex = i;
            break;
          }
        }
      }

      this._updateProvinces();

      const provinceSelect = this.provinceWrapper.tagName === 'SELECT'
        ? this.provinceWrapper
        : this.provinceWrapper.querySelector('select');
      if (provinceSelect && provinceSelect.hasAttribute('data-default')) {
        const defaultProv = provinceSelect.getAttribute('data-default');
        for (let i = 0; i < provinceSelect.options.length; i++) {
          if (provinceSelect.options[i].text === defaultProv) {
            provinceSelect.selectedIndex = i;
            break;
          }
        }
      }
    }

    _updateProvinces() {
      const selected = this.options[this.selectedIndex];
      if (!selected) return;

      const provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');
      const provinceSelect = this.provinceWrapper.tagName === 'SELECT'
        ? this.provinceWrapper
        : this.provinceWrapper.querySelector('select');

      provinceSelect.innerHTML = '';

      if (provinces.length === 0) {
        this.provinceWrapper.hidden = true;
        return;
      }

      provinces.forEach(data => {
        provinceSelect.options.add(new Option(data[1], data[0]));
      });
      this.provinceWrapper.hidden = false;
    }
  }
  customElements.define('country-selector', CountrySelector, { extends: 'select' });
}

/* ============================================================
   cart-page-note — Cart note textarea with auto-save
   ============================================================ */
if (!customElements.get('cart-page-note')) {
  class CartPageNote extends HTMLTextAreaElement {
    connectedCallback() {
      this.addEventListener('change', this._onNoteChanged.bind(this));
    }

    async _onNoteChanged() {
      const toggleBtn = this.hasAttribute('aria-owns')
        ? document.getElementById(this.getAttribute('aria-owns'))
        : null;

      if (toggleBtn) {
        toggleBtn.textContent = this.value === ''
          ? (window.cartPageStrings?.addOrderNote || 'Add order note')
          : (window.cartPageStrings?.editOrderNote || 'Edit order note');
      }

      await fetch(`${window.routes.cart_update_url}`, {
        body: JSON.stringify({ note: this.value }),
        credentials: 'same-origin',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
    }
  }
  customElements.define('cart-page-note', CartPageNote, { extends: 'textarea' });
}

/* ============================================================
   shipping-estimator — Shipping rate calculator
   ============================================================ */
if (!customElements.get('shipping-estimator')) {
  class ShippingEstimator extends HTMLElement {
    connectedCallback() {
      this.submitButton = this.querySelector('[type="button"]');
      if (this.submitButton) {
        this.submitButton.addEventListener('click', this._estimateShipping.bind(this));
      }
    }

    async _estimateShipping() {
      const zip = this.querySelector('[name="shipping-estimator[zip]"]').value;
      const country = this.querySelector('[name="shipping-estimator[country]"]').value;
      const province = this.querySelector('[name="shipping-estimator[province]"]').value;

      this.submitButton.disabled = true;
      this.submitButton.textContent = '...';

      try {
        const prepareResponse = await fetch(
          `${window.routes.cart_url}/prepare_shipping_rates.json?shipping_address[zip]=${encodeURIComponent(zip)}&shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(province)}`,
          { method: 'POST' }
        );

        if (prepareResponse.ok) {
          const rates = await this._getAsyncRates(zip, country, province);
          this._renderRates(rates);
        } else {
          const errors = await prepareResponse.json();
          this._renderError(errors);
        }
      } catch (e) {
        this._renderError({ error: ['An error occurred. Please try again.'] });
      }

      this.submitButton.disabled = false;
      this.submitButton.textContent = this.submitButton.getAttribute('data-label') || 'Calculate shipping';
    }

    async _getAsyncRates(zip, country, province) {
      const response = await fetch(
        `${window.routes.cart_url}/async_shipping_rates.json?shipping_address[zip]=${encodeURIComponent(zip)}&shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(province)}`
      );
      const text = await response.text();
      if (text === 'null') {
        return this._getAsyncRates(zip, country, province);
      }
      return JSON.parse(text).shipping_rates;
    }

    _renderRates(rates) {
      this.querySelector('.shipping-estimator__results')?.remove();

      let ratesList = '';
      rates.forEach(rate => {
        const price = parseFloat(rate.price) === 0
          ? (window.cartPageStrings?.free || 'Free')
          : Shopify.formatMoney(parseFloat(rate.price) * 100);
        ratesList += `<li>${rate.presentment_name}: ${price}</li>`;
      });

      const msg = rates.length === 0
        ? (window.cartPageStrings?.noShippingRates || 'No shipping rates available for this address.')
        : rates.length === 1
          ? (window.cartPageStrings?.oneShippingRate || 'There is one shipping rate for your address:')
          : (window.cartPageStrings?.multipleShippingRates || 'There are multiple shipping rates for your address:');

      this.insertAdjacentHTML('beforeend', `
        <div class="shipping-estimator__results">
          <p>${msg}</p>
          ${ratesList ? `<ul class="shipping-estimator__rates-list">${ratesList}</ul>` : ''}
        </div>
      `);
    }

    _renderError(errors) {
      this.querySelector('.shipping-estimator__results')?.remove();

      let errorList = '';
      Object.keys(errors).forEach(key => {
        errorList += `<li>${key} ${errors[key]}</li>`;
      });

      this.insertAdjacentHTML('beforeend', `
        <div class="shipping-estimator__results shipping-estimator__results--error">
          <p>${window.cartPageStrings?.shippingError || 'There was an error:'}</p>
          <ul class="shipping-estimator__rates-list">${errorList}</ul>
        </div>
      `);
    }
  }
  customElements.define('shipping-estimator', ShippingEstimator);
}

/* ============================================================
   handleCheckoutClick — Upsell product add-to-cart before checkout
   Used by the cart page checkout button when upsell toggle is checked
   ============================================================ */
(function() {
  let isProcessing = false;

  function addUpsellAndCheckout(callback) {
    const form = document.querySelector('form.priority-processing');
    if (!form) { isProcessing = false; return; }
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) { isProcessing = false; return; }

    const formData = new FormData(form);
    formData.append('id', variantInput.value);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (response.ok && callback) callback();
      else isProcessing = false;
    })
    .catch(() => { isProcessing = false; });
  }

  window.handleCheckoutClick = function(element) {
    if (isProcessing) return;

    const checkbox = document.querySelector('#cart-upsell-switch');
    if (checkbox && checkbox.checked) {
      isProcessing = true;
      addUpsellAndCheckout(function() {
        isProcessing = false;
        const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
        if (checkoutBtn) checkoutBtn.click();
      });
    } else {
      const checkoutBtn = document.querySelector('#CartDrawer-Checkout');
      if (checkoutBtn) checkoutBtn.click();
    }
  };
})()

/* ========== END: main-cart.js ========== */

/* ========== FILE: main-search.js ========== */
class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

/* ========== END: main-search.js ========== */

/* ========== FILE: media-gallery.js ========== */

// Media Badges Tooltip
document.addEventListener('click', (e) => {
  const infoBtn = e.target.closest('.product-media-badge__info-btn');
  if (infoBtn) {
    e.stopPropagation();
    const tooltip = infoBtn.nextElementSibling;
    const wasVisible = tooltip.classList.contains('is-visible');
    document.querySelectorAll('.product-media-badge__tooltip.is-visible').forEach((t) => t.classList.remove('is-visible'));
    if (!wasVisible) tooltip.classList.add('is-visible');
    return;
  }
  if (!e.target.closest('.product-media-badge__tooltip')) {
    document.querySelectorAll('.product-media-badge__tooltip.is-visible').forEach((t) => t.classList.remove('is-visible'));
  }
});

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="ProductSwiper"]'),
          thumbnails: this.querySelector('[id^="ProductThumbs"]'),
        };
        this.mql = window.matchMedia('(min-width: 1000px)');
        this.swiperReady = false;
        this._dragged = false;
        this._lastMouseX = null;
      }

      connectedCallback() {
        this.initWhenReady();
      }

      initWhenReady() {
        if (typeof Swiper !== 'undefined') {
          this.init();
        } else {
          const onReady = () => {
            if (typeof Swiper !== 'undefined') {
              this.init();
            } else {
              const interval = setInterval(() => {
                if (typeof Swiper !== 'undefined') {
                  clearInterval(interval);
                  this.init();
                }
              }, 50);
            }
          };
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', onReady);
          } else {
            onReady();
          }
        }
      }

      init() {
        // Re-query elements in case the gallery was replaced via section rendering
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="ProductSwiper"]'),
          thumbnails: this.querySelector('[id^="ProductThumbs"]'),
        };
        if (this.swiperReady || !this.elements.viewer) return;
        this.swiperReady = true;

        this.createSwipers();
        this.setupDOMEvents();
        if (this.dataset.imageZoom !== 'none') this.initPhotoSwipe();

        // Activate deferred images
        const layout = this.elements.viewer.dataset.galleryLayout;
        const isStackedOrColumns = (layout === 'stacked' || layout === 'columns') && this.mql.matches;
        if (isStackedOrColumns) {
          // Stacked/columns shows all slides at once on desktop – activate all deferred images
          const slideCount = this.mainSwiper?.slides?.length || 0;
          for (let i = 0; i < slideCount; i++) {
            this.activateDeferredImage(i);
          }
        } else {
          // Slider mode – activate next two slides ahead
          this.activateDeferredImage(1);
          this.activateDeferredImage(2);
        }

        // Ensure Swiper recalculates height after first image loads (autoHeight fix)
        const firstImg = this.mainSwiper?.slides?.[0]?.querySelector('.product__media img');
        if (firstImg) {
          const updateHeight = () => this.mainSwiper?.update();
          if (firstImg.complete) {
            updateHeight();
          } else {
            firstImg.addEventListener('load', updateHeight, { once: true });
          }
        }

        // Reinitialize swipers on breakpoint change (vertical <-> horizontal thumbnails)
        if (this.elements.thumbnails?.classList.contains('thumbnail-slider--vertical')) {
          this._mqlHandler = () => {
            const activeIndex = this.mainSwiper?.activeIndex || 0;
            this.destroySwipers();
            this.createSwipers();
            if (this.mainSwiper && activeIndex > 0) {
              this.mainSwiper.slideTo(activeIndex, 0);
            }
          };
          this.mql.addEventListener('change', this._mqlHandler);
        } else if (layout === 'stacked' || layout === 'columns') {
          // When resizing from mobile to desktop, activate all deferred images
          this._mqlHandler = () => {
            if (this.mql.matches) {
              const slideCount = this.mainSwiper?.slides?.length || 0;
              for (let i = 0; i < slideCount; i++) {
                this.activateDeferredImage(i);
              }
            }
          };
          this.mql.addEventListener('change', this._mqlHandler);
        }
      }

      createSwipers() {
        const layout = this.elements.viewer.dataset.galleryLayout;
        const isStackedOrColumns = layout === 'stacked' || layout === 'columns';

        // Thumbnail Swiper
        if (this.elements.thumbnails) {
          const isVertical =
            this.elements.thumbnails.classList.contains('thumbnail-slider--vertical') && this.mql.matches;

          const thumbsConfig = {
            slidesPerView: 4.5,
            spaceBetween: 2,
            freeMode: true,
            resistanceRatio: 0,
            watchSlidesProgress: true,
            breakpoints: {
              400: { spaceBetween: 8 },
              750: { slidesPerView: 5.5, spaceBetween: 8 },
              1000: { slidesPerView: 6.5, spaceBetween: 8, allowTouchMove: false },
            },
            on: {
              init: (swiper) => this.updateThumbShadows(swiper),
              slideChange: (swiper) => this.updateThumbShadows(swiper),
              resize: (swiper) => this.updateThumbShadows(swiper),
              setTranslate: (swiper) => this.updateThumbShadows(swiper),
            },
          };

          if (isVertical) {
            thumbsConfig.direction = 'vertical';
            thumbsConfig.slidesPerView = 'auto';
            thumbsConfig.allowTouchMove = false;
            delete thumbsConfig.breakpoints;
          }

          this.thumbsSwiper = new Swiper(this.elements.thumbnails, thumbsConfig);
        }

        // Main Swiper
        const isFullWidth = this.closest('.product')?.classList.contains('product--mobile-full-width');
        const swiperConfig = {
          slidesPerView: 1,
          spaceBetween: isFullWidth ? 0 : 24,
          autoHeight: true,
          resistanceRatio: 0,
          simulateTouch: true,
          touchStartPreventDefault: false,
          breakpoints: {
            750: { spaceBetween: 80 },
            1000: { spaceBetween: 30 },
          },
          navigation: {
            nextEl: this.elements.viewer.querySelector('.swiper-button-next'),
            prevEl: this.elements.viewer.querySelector('.swiper-button-prev'),
          },
          on: {
            slideChange: (swiper) => this.onSlideChanged(swiper),
          },
        };

        if (this.thumbsSwiper) {
          swiperConfig.thumbs = { swiper: this.thumbsSwiper };
        }

        if (isStackedOrColumns) {
          swiperConfig.breakpoints = {
            750: { spaceBetween: 20 },
            1000: { enabled: false, spaceBetween: 0 },
          };
        }

        this.mainSwiper = new Swiper(this.elements.viewer, swiperConfig);

        // On first interaction, activate all deferred images
        this.mainSwiper.on('touchStart', () => {
          if (this._allImagesActivated) return;
          this._allImagesActivated = true;
          for (let i = 0; i < this.mainSwiper.slides.length; i++) {
            this.activateDeferredImage(i);
          }
        });

        // Drag detection (tied to swiper instance, re-registered on each createSwipers)
        this.mainSwiper.on('touchMove', () => {
          this._dragged = true;
        });
        this.mainSwiper.on('touchEnd', () => {
          setTimeout(() => {
            this._dragged = false;
          }, 50);
        });
        this.mainSwiper.on('slideChange', () => this.updateCursor());
      }

      setupDOMEvents() {
        this._navMode = this.getAttribute('data-gallery-navigation') || 'hover';

        if (this._navMode === 'hover') {
          // Cursor SVGs – button-styled from theme icons
          const cursorIcons = this.closest('product-info')?.querySelector('.gallery-cursor-icons') || document.querySelector('.gallery-cursor-icons');
          const prevIconHTML = cursorIcons?.querySelector('.gallery-icon-prev')?.innerHTML || '';
          const nextIconHTML = cursorIcons?.querySelector('.gallery-icon-next')?.innerHTML || '';

          const cSize = 40;
          const cHalf = cSize / 2;
          const cIconSize = cSize * 0.32;
          const cOffset = (cSize - cIconSize) / 2;
          const rootStyles = getComputedStyle(document.documentElement);
          const cBg = `rgb(${rootStyles.getPropertyValue('--color-background').trim()})`;
          const cFg = `rgb(${rootStyles.getPropertyValue('--color-foreground').trim()})`;
          const cRadius = rootStyles.getPropertyValue('--buttons-radius-outset')?.trim() || '7px';
          const cBorder = `rgba(${rootStyles.getPropertyValue('--color-foreground').trim()}, 0.15)`;

          const buildGalleryCursor = (iconHTML, fallback) => {
            if (!iconHTML) return fallback;
            const colored = iconHTML.replace(/currentColor/g, cFg);
            const parser = new DOMParser();
            const doc = parser.parseFromString(colored, 'image/svg+xml');
            const srcSvg = doc.querySelector('svg');
            const viewBox = srcSvg?.getAttribute('viewBox') || '0 0 14 14';
            // Scale up stroke-width so it stays visible at cursor size
            const vbParts = viewBox.split(/\s+/).map(Number);
            const vbSize = Math.max(vbParts[2] || 14, vbParts[3] || 14);
            const scaleFactor = vbSize / cIconSize;
            srcSvg?.querySelectorAll('[stroke-width]').forEach(el => {
              const sw = parseFloat(el.getAttribute('stroke-width')) || 1;
              el.setAttribute('stroke-width', (sw * scaleFactor).toFixed(2));
            });
            const inner = srcSvg?.innerHTML || '';
            const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${cSize}' height='${cSize}' viewBox='0 0 ${cSize} ${cSize}'><rect x='.5' y='.5' width='${cSize - 1}' height='${cSize - 1}' rx='${parseFloat(cRadius)}' fill='${cBg}' stroke='${cBorder}'/><svg x='${cOffset}' y='${cOffset}' width='${cIconSize}' height='${cIconSize}' viewBox='${viewBox}'>${inner}</svg></svg>`;
            return `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${cHalf} ${cHalf}, ${fallback}`;
          };

          this._cursorLeft = buildGalleryCursor(prevIconHTML, 'w-resize');
          this._cursorRight = buildGalleryCursor(nextIconHTML, 'e-resize');

          // Click navigation (references this.mainSwiper dynamically)
          this.elements.viewer.addEventListener('click', (e) => {
            if (this._dragged) return;
            if (!this.mainSwiper || !this.mainSwiper.enabled) return;
            if (e.target.closest('.product__media-icon')) return;
            if (e.target.closest('.swiper-button-prev') || e.target.closest('.swiper-button-next')) return;
            if (e.target.closest('.deferred-media__poster')) return;
            if (e.target.closest('.video-wrapper')) return;

            const rect = this.elements.viewer.getBoundingClientRect();
            const isLeft = e.clientX - rect.left < rect.width / 2;

            if (this.mainSwiper.isBeginning) {
              this.mainSwiper.slideNext();
            } else if (this.mainSwiper.isEnd) {
              this.mainSwiper.slidePrev();
            } else if (isLeft) {
              this.mainSwiper.slidePrev();
            } else {
              this.mainSwiper.slideNext();
            }
          });

          // Cursor feedback
          this.elements.viewer.addEventListener('mousemove', (e) => {
            this._lastMouseX = e.clientX;
            this.updateCursor();
          });

          this.elements.viewer.addEventListener('mouseleave', () => {
            this._lastMouseX = null;
            this.elements.viewer.style.cursor = '';
          });
        }

        // Nav bar (dots mode) – arrows + dot clicks
        const navPrev = this.querySelector('.product-gallery__nav-prev');
        const navNext = this.querySelector('.product-gallery__nav-next');
        if (navPrev) {
          navPrev.addEventListener('click', () => this.mainSwiper?.slidePrev());
        }
        if (navNext) {
          navNext.addEventListener('click', () => this.mainSwiper?.slideNext());
        }
        this._dots = this.querySelectorAll('.product-gallery__nav-dots .swiper-pagination-bullet');
        this._dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.mainSwiper?.slideTo(i));
        });

        // Thumbnail clicks
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbSlide) => {
            const button = thumbSlide.querySelector('button');
            if (button) {
              button.addEventListener('click', () => {
                this.setActiveMedia(thumbSlide.dataset.target, false);
              });
            }
          });
        }
      }

      updateCursor() {
        if (this._lastMouseX === null || !this.mainSwiper || !this.mainSwiper.enabled) {
          this.elements.viewer.style.cursor = '';
          return;
        }
        const rect = this.elements.viewer.getBoundingClientRect();
        const isLeft = this._lastMouseX - rect.left < rect.width / 2;

        if (this.mainSwiper.isBeginning) {
          this.elements.viewer.style.cursor = this._cursorRight;
        } else if (this.mainSwiper.isEnd) {
          this.elements.viewer.style.cursor = this._cursorLeft;
        } else {
          this.elements.viewer.style.cursor = isLeft ? this._cursorLeft : this._cursorRight;
        }
      }

      destroySwipers() {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }
        if (this.thumbsSwiper) {
          this.thumbsSwiper.destroy(true, true);
          this.thumbsSwiper = null;
        }
      }

      initPhotoSwipe() {
        const slides = this.elements.viewer.querySelectorAll('.swiper-slide[data-media-id]');

        // Collect image data from data attributes (works even for deferred/template images)
        this.pswpItems = [];
        slides.forEach((slide, index) => {
          const container = slide.querySelector('.product-media-container[data-pswp-src]');
          if (!container) return;
          const src = container.dataset.pswpSrc;
          const ratio = parseFloat(container.dataset.pswpRatio) || 1;
          const alt = container.dataset.pswpAlt || '';
          const baseUrl = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
          const sep = baseUrl.includes('?') ? '&' : '?';
          const widths = [990, 1200, 1446, 1680, 1946];
          const srcset = widths.map((w) => `${baseUrl}${sep}width=${w} ${w}w`).join(', ');
          this.pswpItems.push({
            src: `${baseUrl}${sep}width=1946`,
            srcset: srcset,
            msrc: src,
            width: 1946,
            height: Math.round(1946 / ratio),
            alt: alt,
            slideIndex: index,
          });
        });

        // Click handler on zoom icons
        this.elements.viewer.querySelectorAll('.product__media-icon').forEach((icon) => {
          icon.style.cursor = 'pointer';
          icon.addEventListener('click', (e) => {
            e.stopPropagation();
            const slide = icon.closest('.swiper-slide');
            if (!slide) return;
            const slideIndex = [...slides].indexOf(slide);
            const pswpIndex = this.pswpItems.findIndex((item) => item.slideIndex === slideIndex);
            if (pswpIndex >= 0) this.openPhotoSwipe(pswpIndex);
          });
        });
      }

      openPhotoSwipe(index) {
        if (typeof window.PhotoSwipeLightbox === 'undefined') return;

        const pswpIcons = this.parentElement?.querySelector('.pswp-icons') || document.querySelector('.pswp-icons');
        const closeSVG = pswpIcons?.querySelector('.pswp-icon-close')?.innerHTML || '';
        const prevSVG = pswpIcons?.querySelector('.pswp-icon-prev')?.innerHTML || '';
        const nextSVG = pswpIcons?.querySelector('.pswp-icon-next')?.innerHTML || '';
        const zoomSVG = pswpIcons?.querySelector('.pswp-icon-zoom')?.innerHTML || '';
        const zoomInSVG = pswpIcons?.querySelector('.pswp-icon-zoom-in')?.innerHTML || '';
        const zoomOutSVG = pswpIcons?.querySelector('.pswp-icon-zoom-out')?.innerHTML || '';

        const lightbox = new window.PhotoSwipeLightbox({
          dataSource: this.pswpItems,
          pswpModule: window.PhotoSwipe,
          bgOpacity: 1,
          showHideAnimationType: 'fade',
          bgClickAction: 'none',
          tapAction: 'toggle-controls',
          close: true,
          counter: false,
          arrowKeys: true,
        });

        // Prevent PhotoSwipe's focus restoration from scrolling the page
        let savedY = 0;

        lightbox.on('firstUpdate', () => {
          const el = lightbox.pswp.element;
          const close = el.querySelector('.pswp__button--close');
          const prev = el.querySelector('.pswp__button--arrow--prev');
          const next = el.querySelector('.pswp__button--arrow--next');
          const zoom = el.querySelector('.pswp__button--zoom');
          if (close) close.innerHTML = closeSVG;
          if (prev) prev.innerHTML = prevSVG;
          if (next) next.innerHTML = nextSVG;
          if (zoom && zoomSVG) zoom.innerHTML = zoomSVG;

          const btn = close || prev || next;
          if (btn && zoomInSVG && zoomOutSVG) {
            const btnStyle = getComputedStyle(btn);
            const bg = btnStyle.backgroundColor;
            const fg = btnStyle.color;
            const radius = parseFloat(btnStyle.borderRadius) || 7;
            const borderColor = btnStyle.borderColor;
            const size = parseFloat(btnStyle.width) || 40;
            const half = size / 2;
            const iconSize = size * 0.32;
            const offset = (size - iconSize) / 2;

            function buildCursorSVG(iconHTML) {
              const colored = iconHTML.replace(/currentColor/g, fg);
              const parser = new DOMParser();
              const doc = parser.parseFromString(colored, 'image/svg+xml');
              const srcSvg = doc.querySelector('svg');
              const viewBox = srcSvg?.getAttribute('viewBox') || '0 0 8 8';
              const inner = srcSvg?.innerHTML || '';
              const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'><rect x='.5' y='.5' width='${size - 1}' height='${size - 1}' rx='${radius}' fill='${bg}' stroke='${borderColor}'/><svg x='${offset}' y='${offset}' width='${iconSize}' height='${iconSize}' viewBox='${viewBox}'>${inner}</svg></svg>`;
              return `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${half} ${half}`;
            }

            el.style.setProperty('--pswp-cursor-zoom-in', buildCursorSVG(zoomInSVG) + ', zoom-in');
            el.style.setProperty('--pswp-cursor-zoom-out', buildCursorSVG(zoomOutSVG) + ', zoom-out');
          }

          const pswp = lightbox.pswp;
          const container = el.querySelector('.pswp__container');

          const origMoveIndexBy = pswp.mainScroll.moveIndexBy.bind(pswp.mainScroll);
          pswp.mainScroll.moveIndexBy = (delta, animate, velocity) => {
            container.style.transition = 'transform 0.35s cubic-bezier(0.25, 0.1, 0.25, 1)';
            origMoveIndexBy(delta, false);
            container.addEventListener('transitionend', () => {
              container.style.transition = '';
            }, { once: true });
          };

          el.addEventListener('pointerdown', () => {
            container.style.transition = '';
          });
        });

        lightbox.on('close', () => {
          savedY = window.scrollY;
        });

        lightbox.on('destroy', () => {
          window.scrollTo(0, savedY);
        });

        lightbox.init();
        lightbox.loadAndOpen(index);
      }

      activateDeferredImage(slideIndex) {
        const slide = this.mainSwiper?.slides?.[slideIndex];
        if (!slide) return;
        const template = slide.querySelector('template.deferred-image');
        if (!template) return;
        const container = template.parentElement;
        container.appendChild(template.content.cloneNode(true));
        template.remove();
      }

      onSlideChanged(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;


        swiper.slides.forEach((slide) => slide.classList.remove('is-active'));
        activeSlide.classList.add('is-active');
        this.activateDeferredImage(swiper.activeIndex);
        this.activateDeferredImage(swiper.activeIndex + 1);


        if (this._dots?.length) {
          this._dots.forEach((dot, i) => {
            dot.classList.toggle('swiper-pagination-bullet-active', i === swiper.activeIndex);
          });
        }


        if (this.elements.thumbnails) {
          const mediaId = activeSlide.dataset.mediaId;
          const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(thumbnail);
        }

        this.playActiveMedia(activeSlide);


        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${activeSlide.dataset.mediaId}"]`
          );
          if (thumbnail) {
            this.announceLiveRegion(activeSlide, thumbnail.dataset.mediaPosition);
          }
        }
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.mainSwiper) return;

        const slides = this.mainSwiper.slides;
        let index = [...slides].findIndex((s) => s.dataset.mediaId === mediaId);


        if (index < 0) return;


        const currentActive = [...slides].find((s) => s.classList.contains('is-active'));
        if (currentActive?.dataset.mediaId === mediaId) {
          if (this.elements.thumbnails) {
            this.setActiveThumbnail(this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`));
          }
          return;
        }


        slides.forEach((slide) => slide.classList.remove('is-active'));
        if (slides[index]) slides[index].classList.add('is-active');

        this.preventStickyHeader();



        const stickyBarVisible = !!document.querySelector('sticky-atc:not([hidden])');

        if (this.mainSwiper.enabled) {
          this.mainSwiper.slideTo(index);
        } else if (!stickyBarVisible) {

          const targetSlide = slides[index];
          if (targetSlide) {
            const targetRect = targetSlide.getBoundingClientRect();
            if (targetRect.top < -0.5) {
              const top = targetRect.top + window.scrollY;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          }
        }


        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(thumbnail);
          if (thumbnail) {
            this.announceLiveRegion(slides[index], thumbnail.dataset.mediaPosition);
          }
        }

        this.playActiveMedia(slides[index]);
      }

      filterByVariant(selectedOptions, featuredMediaId) {
        clearTimeout(this._ttGalerie);
        this._ttGalerie = setTimeout(() => this.ttGalerieJetzt(selectedOptions, featuredMediaId), 340);
      }

      ttGalerieJetzt(selectedOptions, featuredMediaId) {
        const wrapper = this.elements.viewer?.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        const lowerOptions = selectedOptions.map((o) => o.toLowerCase().trim());

        // Parse all known option values from data attribute (|||red|||blue|||m|||l|||)
        const allOptionValuesRaw = this.dataset.allOptionValues || '';
        const allOptionValues = allOptionValuesRaw.split('|||').map((v) => v.trim()).filter(Boolean);
        const isTaggedAlt = (alt) => allOptionValues.includes(alt);
        const variantBilder = this.dataset.variantBilder || '|';
        const gewaehltesBild = featuredMediaId ? String(featuredMediaId).split('-').pop() : '';
        const variantRegel = (nr) => (nr && variantBilder.includes(`|${nr}|`) ? nr === gewaehltesBild : null);

        // Check if any slide has alt text matching any selected option (= has_tagged_media logic)
        const allSlides = wrapper.querySelectorAll('.product__media-item');
        const hasTaggedMedia = [...allSlides].some((slide) => {
          const alt = (slide.dataset.mediaAlt || '').toLowerCase().trim();
          return alt && isTaggedAlt(alt);
        });

        let filteringChanged = false;

        // Toggle is-filtered + swiper-slide class on all media items
        // Only filter slides whose alt IS a recognized option value
        allSlides.forEach((slide) => {
          const alt = (slide.dataset.mediaAlt || '').toLowerCase().trim();
          let shouldShow = !hasTaggedMedia || !alt || !isTaggedAlt(alt) || lowerOptions.includes(alt);
          const regelBild = variantRegel((slide.dataset.mediaId || '').split('-').pop());
          if (regelBild !== null) shouldShow = regelBild;
          const isCurrentlyFiltered = slide.classList.contains('is-filtered');

          if (shouldShow && isCurrentlyFiltered) {
            slide.classList.remove('is-filtered');
            slide.classList.add('swiper-slide');
            filteringChanged = true;
          } else if (!shouldShow && !isCurrentlyFiltered) {
            slide.classList.add('is-filtered');
            slide.classList.remove('swiper-slide');
            slide.classList.remove('is-active');
            filteringChanged = true;
          }
        });

        // Filter thumbnails based on visible slides
        if (this.elements.thumbnails) {
          const thumbWrapper = this.elements.thumbnails.querySelector('.swiper-wrapper');
          if (thumbWrapper) {
            thumbWrapper.querySelectorAll('.thumbnail-list__item').forEach((thumb) => {
              const target = thumb.dataset.target;
              const matchingSlide = wrapper.querySelector(`.swiper-slide[data-media-id="${target}"]`);
              if (matchingSlide) {
                thumb.classList.remove('is-filtered');
                thumb.classList.add('swiper-slide');
              } else {
                thumb.classList.add('is-filtered');
                thumb.classList.remove('swiper-slide');
              }
            });
          }
        }

        // Filter dots
        const dots = this.querySelectorAll('.product-gallery__nav-dots .swiper-pagination-bullet');
        if (dots.length) {
          let visibleDotIndex = 0;
          dots.forEach((dot) => {
            const alt = (dot.dataset.mediaAlt || '').toLowerCase().trim();
            let shouldShow = !hasTaggedMedia || !alt || !isTaggedAlt(alt) || lowerOptions.includes(alt);
            const regelPunkt = variantRegel(dot.dataset.mediaNr || '');
            if (regelPunkt !== null) shouldShow = regelPunkt;
            dot.classList.toggle('is-filtered', !shouldShow);
            if (shouldShow) {
              dot.classList.toggle('swiper-pagination-bullet-active', visibleDotIndex === 0);
              visibleDotIndex++;
            }
          });
          // Re-bind dot click handlers with correct indices
          this._dots = this.querySelectorAll('.product-gallery__nav-dots .swiper-pagination-bullet:not(.is-filtered)');
          this._dots.forEach((dot, i) => {
            dot.onclick = () => this.mainSwiper?.slideTo(i);
          });
        }

        // Rebuild swipers if filtering changed (Swiper caches slides internally)
        if (filteringChanged) {
          this.destroySwipers();
          this.swiperReady = false;
          this.createSwipers();
          this.swiperReady = true;
        }

        // Navigate to variant featured media
        if (featuredMediaId) {
          const sectionId = this.id?.replace('MediaGallery-', '');
          const mediaId = `${sectionId}-${featuredMediaId}`;
          // Use setActiveMedia for smooth sliding from current position
          if (filteringChanged) {
            // After swiper rebuild: jump instantly, then user sees correct slide
            this.setActiveMedia(mediaId, false);
          } else {
            // No rebuild: smooth slide from current position
            this.setActiveMedia(mediaId, false);
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((el) => el.removeAttribute('aria-current'));
        const button = thumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', true);


        if (this.thumbsSwiper) {
          const thumbIndex = [...this.thumbsSwiper.slides].indexOf(thumbnail);
          if (thumbIndex >= 0) {
            const spv = this.thumbsSwiper.params.slidesPerView;
            const centerOffset = typeof spv === 'number' ? Math.floor(spv / 2) : 2;
            this.thumbsSwiper.slideTo(Math.max(0, thumbIndex - centerOffset));
          }
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position
          );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;


        window.pauseAllMedia();
        this.elements.viewer.querySelectorAll('native-video').forEach((v) => v.pause());
        this.elements.viewer.querySelectorAll('external-video').forEach((v) => v.pause());


        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      updateThumbShadows(swiper) {
        if (!this.elements.thumbnails || !swiper) return;
        const el = this.elements.thumbnails;
        const tol = 2;
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const cur = swiper.translate;
        const scrollable = min - max > tol;
        el.classList.toggle('shadow-left', scrollable && cur < min - tol);
        el.classList.toggle('shadow-right', scrollable && cur > max + tol);
      }

      disconnectedCallback() {
        this.destroySwipers();
        if (this._mqlHandler) {
          this.mql.removeEventListener('change', this._mqlHandler);
        }
        this.swiperReady = false;
      }
    }
  );
}

class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });
  }
}

customElements.define('password-modal', PasswordModal);

if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {


      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }


    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {

      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    if (this.closest('search-drawer')) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {

    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {

        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');



    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  initTabs() {
    const tabsContainer = this.querySelector('[data-predictive-search-tabs]');
    if (!tabsContainer) return;

    const buttons = tabsContainer.querySelectorAll('.predictive-search-tabs__btn');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        tabsContainer.querySelectorAll('.predictive-search-tabs__panel').forEach((panel) => {
          panel.classList.remove('is-active');
        });

        const target = tabsContainer.querySelector('#' + btn.getAttribute('aria-controls'));
        if (target) target.classList.add('is-active');
      });
    });
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {

          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
    this.initTabs();
    this.toggleDrawerFooter(true);
  }

  toggleDrawerFooter(show) {
    const drawer = this.closest('search-drawer');
    if (!drawer) return;
    const footer = drawer.querySelector('[data-search-drawer-footer]');
    if (footer) footer.hidden = !show;
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    if (!this.closest('search-drawer')) {
      this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    }
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    if (clearSearchTerm) this.toggleDrawerFooter(false);
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

if (!customElements.get('price-per-item')) {
  customElements.define(
    'price-per-item',
    class PricePerItem extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.input = document.getElementById(`Quantity-${this.dataset.sectionId || this.dataset.variantId}`);
        if (this.input) {
          this.input.addEventListener('change', this.onInputChange.bind(this));
        }

        this.getVolumePricingArray();
      }

      updatePricePerItemUnsubscriber = undefined;
      variantIdChangedUnsubscriber = undefined;

      connectedCallback() {

        this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.variantId = event.data.variant.id.toString();
          this.getVolumePricingArray();
        });

        this.updatePricePerItemUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (response) => {
          if (!response.cartData) return;


          if (response.cartData['variant_id'] !== undefined) {
            if (response.productVariantId === this.variantId) this.updatePricePerItem(response.cartData.quantity);

          } else if (response.cartData.item_count !== 0) {
            const isVariant = response.cartData.items.find((item) => item.variant_id.toString() === this.variantId);
            if (isVariant && isVariant.id.toString() === this.variantId) {

              this.updatePricePerItem(isVariant.quantity);
            } else {

              this.updatePricePerItem(0);
            }

          } else {
            this.updatePricePerItem(0);
          }
        });
      }

      disconnectedCallback() {
        if (this.updatePricePerItemUnsubscriber) {
          this.updatePricePerItemUnsubscriber();
        }
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber();
        }
      }

      onInputChange() {
        this.updatePricePerItem();
      }

      updatePricePerItem(updatedCartQuantity) {
        if (this.input) {
          this.enteredQty = parseInt(this.input.value);
          this.step = parseInt(this.input.step)
        }



        this.currentQtyForVolumePricing = updatedCartQuantity === undefined ? this.getCartQuantity(updatedCartQuantity) + this.enteredQty : this.getCartQuantity(updatedCartQuantity) + parseInt(this.step);

        if (this.classList.contains('variant-item__price-per-item')) {
          this.currentQtyForVolumePricing = this.getCartQuantity(updatedCartQuantity);
        }
        for (let pair of this.qtyPricePairs) {
          if (this.currentQtyForVolumePricing >= pair[0]) {
            const pricePerItemCurrent = document.querySelector(`price-per-item[id^="Price-Per-Item-${this.dataset.sectionId || this.dataset.variantId}"] .price-per-item span`);
            this.classList.contains('variant-item__price-per-item') ? pricePerItemCurrent.innerHTML = window.quickOrderListStrings.each.replace('[money]', pair[1]) : pricePerItemCurrent.innerHTML = pair[1];
            break;
          }
        }
      }

      getCartQuantity(updatedCartQuantity) {
        return (updatedCartQuantity || updatedCartQuantity === 0) ? updatedCartQuantity : parseInt(this.input.dataset.cartQuantity);
      }

      getVolumePricingArray() {
        const volumePricing = document.getElementById(`Volume-${this.dataset.sectionId || this.dataset.variantId}`);
        this.qtyPricePairs = [];

        if (volumePricing) {
          volumePricing.querySelectorAll('li').forEach(li => {
            const qty = parseInt(li.querySelector('span:first-child').textContent);
            const price = (li.querySelector('span:not(:first-child):last-child').dataset.text);
            this.qtyPricePairs.push([qty, price]);
          });
        }
        this.qtyPricePairs.reverse();
      }
    }
  );
}

if (!customElements.get('product-drawer')) {
  customElements.define(
    'product-drawer',
    class ProductDrawer extends HTMLElement {
      constructor() {
        super();

        this.overlay = this.querySelector('.product-drawer__overlay');
        this.panel = this.querySelector('.product-drawer__panel');
        this.body = this.querySelector('.product-drawer__body');
        this.closeBtn = this.querySelector('.product-drawer__close');

        this.closeBtn?.addEventListener('click', () => this.hide());
        this.overlay?.addEventListener('click', () => this.hide());

        this.addEventListener('click', (e) => {
          if (!this.panel.contains(e.target)) this.hide();
        });
        document.addEventListener('keydown', (e) => {
          if (e.code === 'Escape' && this.classList.contains('active')) this.hide();
        });


        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'product-form' && this.classList.contains('active')) {
              this.hide({ keepOverflowHidden: true });
            }
          });
        }
      }


      show(opener) {
        if (!opener) return;

        this.openedBy = opener;
        const productUrl = opener.getAttribute('data-product-url');
        if (!productUrl) return;


        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const loadingStartTime = Date.now();


        this._cancelContentClear();

        this.body.innerHTML = '';

        fetch(productUrl)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');


            const template = doc.querySelector('template[data-product-drawer-content]');
            if (!template) return;


            let contentHTML = template.innerHTML;


            const productInfo = template.content.querySelector('product-info');
            if (productInfo) {
              const sectionId = productInfo.dataset.section;
              if (sectionId) {
                this._originalSectionId = sectionId;
                this._drawerSectionId = `product-drawer-${sectionId}`;
                contentHTML = contentHTML.replaceAll(sectionId, this._drawerSectionId);

                contentHTML = contentHTML.replace(
                  `data-section="${this._drawerSectionId}"`,
                  `data-section="${this._drawerSectionId}" data-original-section="${sectionId}"`
                );
              }
            }




            contentHTML = contentHTML.replace(/<script\b(?![^>]*type\s*=\s*["']application\/json["'])[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');

            HTMLUpdateUtility.setInnerHTML(this.body, contentHTML);


            this._registerPreProcessCallback();


            this._setupVariantImageSwitching();

            // Initialize volume discounts inside the drawer
            if (typeof initializeQuantityBreaks === 'function') {

              initializeQuantityBreaks();
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            this._open();
          })
          .catch((err) => {
            console.error('[ProductDrawer] Failed to load product:', err);
          })
          .finally(() => {
            const elapsed = Date.now() - loadingStartTime;
            const minDisplayTime = 500;
            const remaining = Math.max(0, minDisplayTime - elapsed);

            setTimeout(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            }, remaining);
          });
      }


      hide({ keepOverflowHidden = false } = {}) {
        this.classList.remove('active');
        removeTrapFocus(this.openedBy);
        if (!keepOverflowHidden) {

          const cartDrawer = document.querySelector('cart-drawer');
          const cartOpen = cartDrawer && cartDrawer.classList.contains('active');
          if (!cartOpen) document.body.classList.remove('overflow-hidden');
        }


        const cart = document.querySelector('cart-drawer');
        if (cart && this.openedBy) cart.setActiveElement(this.openedBy);


        this._variantChangeUnsubscriber?.();
        this._variantChangeUnsubscriber = null;


        this._clearContentAfterTransition();
      }



      _open() {
        this.style.visibility = '';
        this.classList.add('active');
        trapFocus(this.panel, this.panel);
        document.body.classList.add('overflow-hidden');
      }


      _clearContentAfterTransition() {
        this._cancelContentClear();

        const clear = () => {
          this._cancelContentClear();
          this.body.innerHTML = '';
        };

        this._transitionEndHandler = (e) => {
          if (e.propertyName === 'transform') clear();
        };
        this.panel?.addEventListener('transitionend', this._transitionEndHandler);


        this._clearFallbackTimer = setTimeout(clear, 800);
      }


      _cancelContentClear() {
        if (this._clearFallbackTimer) {
          clearTimeout(this._clearFallbackTimer);
          this._clearFallbackTimer = null;
        }
        if (this._transitionEndHandler) {
          this.panel?.removeEventListener('transitionend', this._transitionEndHandler);
          this._transitionEndHandler = null;
        }
      }


      _registerPreProcessCallback() {
        const productInfo = this.body.querySelector('product-info');
        if (!productInfo || !productInfo.addPreProcessCallback) return;

        const drawerSectionId = this._drawerSectionId;
        const originalSectionId = this._originalSectionId;
        if (!originalSectionId) return;

        productInfo.addPreProcessCallback((html) => {
          if (html.innerHTML) {
            html.innerHTML = html.innerHTML.replaceAll(originalSectionId, drawerSectionId);
          }
        });




        this.body.addEventListener('product-info:loaded', ({ target }) => {
          if (target.addPreProcessCallback) {
            target.addPreProcessCallback((html) => {
              if (html.innerHTML) {
                html.innerHTML = html.innerHTML.replaceAll(originalSectionId, drawerSectionId);
              }
            });
          }
        });
      }


      _setupVariantImageSwitching() {
        const imageDataEl = this.body.querySelector('[data-drawer-variant-images]');
        const thumbImg = this.body.querySelector('.product-drawer__thumb-img');
        if (!imageDataEl || !thumbImg) return;

        try {
          const variantImages = JSON.parse(imageDataEl.textContent);
          const defaultSrc = thumbImg.src;

          const productInfo = this.body.querySelector('product-info');
          if (!productInfo) return;

          if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {

            this._variantChangeUnsubscriber?.();

            this._variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {

              const drawerSectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
              if (data.sectionId !== drawerSectionId) return;

              const variantId = data.variant?.id;
              if (!variantId) return;

              const imgUrl = variantImages[variantId];
              if (imgUrl) {
                thumbImg.src = imgUrl;
                thumbImg.srcset = '';
              } else {
                thumbImg.src = defaultSrc;
                thumbImg.srcset = '';
              }
            });
          }
        } catch (e) {

        }
      }
    }
  );


  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-product-drawer]');
    if (!opener) return;

    event.preventDefault();
    const drawer = document.querySelector(opener.dataset.productDrawer);
    if (drawer) drawer.show(opener);
  });
}

if (!customElements.get('size-chart-drawer')) {
  customElements.define(
    'size-chart-drawer',
    class SizeChartDrawer extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        document.body.appendChild(this);
      }

      _init() {
        if (this._ready) return;
        this._ready = true;
        this.panel = this.querySelector('.product-drawer__panel');

        this.querySelector('.product-drawer__close')?.addEventListener('click', () => this.hide());
        this.addEventListener('click', (e) => {
          if (!this.panel?.contains(e.target)) this.hide();
        });
        document.addEventListener('keydown', (e) => {
          if (e.code === 'Escape' && this.classList.contains('active')) this.hide();
        });
      }

      show() {
        this._init();
        this.style.visibility = '';
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        if (this.panel) trapFocus(this.panel, this.panel);
      }

      hide() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus();
      }
    }
  );


  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-size-chart-toggle]');
    if (!toggle) return;
    e.preventDefault();
    const drawer = document.querySelector(toggle.getAttribute('data-size-chart-toggle'));
    if (drawer) drawer.show();
  });
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const loadingStartTime = Date.now();

        this.updateSellingPlanFromBundle();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const productDrawer = this.closest('product-drawer');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (productDrawer) {

              const panel = productDrawer.querySelector('.product-drawer__panel');
              const renderCart = () => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              };
              if (panel) {
                const onEnd = (e) => {
                  if (e.propertyName === 'transform') {
                    panel.removeEventListener('transitionend', onEnd);
                    clearTimeout(fallback);
                    renderCart();
                  }
                };
                panel.addEventListener('transitionend', onEnd);

                const fallback = setTimeout(() => {
                  panel.removeEventListener('transitionend', onEnd);
                  renderCart();
                }, 400);
              } else {
                setTimeout(renderCart, 400);
              }
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const elapsed = Date.now() - loadingStartTime;
            const minDisplayTime = 500;
            const remaining = Math.max(0, minDisplayTime - elapsed);

            setTimeout(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            }, remaining);

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Beschriftet den Knopf, ohne den Pfeil zu verlieren. textContent
      // ersetzt ALLES im span, also auch das SVG daneben.
      setSubmitButtonText(text) {
        const pfeil = this.submitButtonText.querySelector('.btn-arrow');
        this.submitButtonText.textContent = text;
        if (pfeil) this.submitButtonText.appendChild(pfeil);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.setSubmitButtonText(text);
        } else {
          this.submitButton.removeAttribute('disabled');
          const customText = this.submitButton.dataset.customText;
          this.setSubmitButtonText(customText || window.variantStrings.addToCart);
        }
      }

      updateSellingPlanFromBundle() {
        const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        if (!sellingPlanInput) return;

        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const variantPicker = productInfo.querySelector('variant-picker');
        if (!variantPicker) return;

        const bundle = variantPicker.querySelector('.bundle');
        const isSubscriptionOnly = bundle && bundle.dataset.subscriptionOnly === 'true';
        const toggle = variantPicker.querySelector('.bundle-subscription-toggle__input');

        let subscriptionActive = false;
        if (isSubscriptionOnly) {
          subscriptionActive = true;
        } else if (toggle && toggle.checked) {
          subscriptionActive = true;
        }

        if (!subscriptionActive) {
          sellingPlanInput.value = '';
          return;
        }

        const variantId = this.variantIdInput.value;
        const planInput = variantPicker.querySelector(`input[name="sellingplaninput"][data-variant-id="${variantId}"]`);
        sellingPlanInput.value = planInput ? planInput.dataset.sellingPlanId : '';
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        clearTimeout(this._ttTausch);
        this._ttKlick = performance.now();
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => new Promise((weiter) => {
            const rest = 400 - (performance.now() - (this._ttKlick || 0));
            clearTimeout(this._ttTausch);
            if (rest > 0) this._ttTausch = setTimeout(() => weiter(responseText), rest);
            else weiter(responseText);
          }))
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {

            document.querySelector(`#${targetId}`)?.focus({ preventScroll: true });
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = (productInfoNode.querySelector('variant-selects [data-selected-variant]') || productInfoNode.querySelector('variant-picker [data-selected-variant]'))?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects') || html.querySelector('variant-picker');
        if (variantSelects && this.variantSelectors) {
          this.preProcessHtmlCallbacks?.forEach((callback) => callback(variantSelects));


          const wrapper = document.createElement('div');
          HTMLUpdateUtility.setInnerHTML(wrapper, variantSelects.outerHTML);
          const newNode = wrapper.firstChild;
          this.variantSelectors.replaceWith(newNode);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variant) {
        const currentGallery = this.querySelector('media-gallery');
        const variantFeaturedMediaId = variant?.featured_media?.id;

        // Use client-side filtering if available (keeps swiper intact, smooth slide)
        if (currentGallery?.filterByVariant && variant?.options) {
          currentGallery.filterByVariant(variant.options, variantFeaturedMediaId);

          const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
          const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
          if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
          return;
        }

        // Fallback: full gallery replacement
        const newGallery = html.querySelector('media-gallery');
        if (currentGallery && newGallery) {
          if (currentGallery.destroySwipers) currentGallery.destroySwipers();
          currentGallery.innerHTML = newGallery.innerHTML;
          Array.from(newGallery.attributes).forEach((attr) => {
            currentGallery.setAttribute(attr.name, attr.value);
          });
          currentGallery.swiperReady = false;
          if (currentGallery.initWhenReady) {
            currentGallery.initWhenReady();
          }
          if (variantFeaturedMediaId && currentGallery.setActiveMedia) {
            const sectionId = currentGallery.id?.replace('MediaGallery-', '');
            currentGallery.setActiveMedia(`${sectionId}-${variantFeaturedMediaId}`, false);
          }
        }

        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        const spinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            const spinner = this.querySelector('.quantity__rules-cart .loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);

                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects') || this.querySelector('variant-picker');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends DeferredMedia {
      constructor() {
        super();
      }

      loadContent() {
        super.loadContent();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      }
    }
  );
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const loadingStartTime = Date.now();

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            const elapsed = Date.now() - loadingStartTime;
            const minDisplayTime = 500;
            const remaining = Math.max(0, minDisplayTime - elapsed);

            setTimeout(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener.querySelector('.loading__spinner').classList.add('hidden');
            }, remaining);
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }

          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');

        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch(() => {







          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.setRequestStarted(false);
          });
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (section.section === 'cart-drawer') {
            sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length.length === 0);
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}

if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}

if (!customElements.get('search-drawer')) {
  customElements.define(
    'search-drawer',
    class SearchDrawer extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        document.body.appendChild(this);
      }

      _init() {
        if (this._ready) return;
        this._ready = true;

        this.panel = this.querySelector('.search-drawer__panel');
        this.searchInput = this.querySelector('input[type="search"]');
        this.predictiveSearch = this.querySelector('predictive-search');

        this.querySelector('.search-drawer__close')?.addEventListener('click', () => this.hide());
        this.addEventListener('click', (e) => {
          if (!this.panel?.contains(e.target)) this.hide();
        });
        this.addEventListener('keyup', (e) => {
          if (e.code === 'Escape') this.hide();
        });
      }

      show(opener) {
        this._init();
        this.openedBy = opener;
        this.style.visibility = '';
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        if (this.panel) trapFocus(this.panel, this.panel);


        requestAnimationFrame(() => {
          if (this.searchInput) this.searchInput.focus();
        });
      }

      hide() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.openedBy);


        if (this.predictiveSearch) {
          this.predictiveSearch.close(true);
        }
      }
    }
  );


  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-search-drawer-trigger]');
    if (!trigger) return;

    e.preventDefault();
    const drawer = document.querySelector('search-drawer');
    if (drawer) drawer.show(trigger);
  });
}

if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}

if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}

if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.formId = this.getAttribute('form-id');
      }


      get mainForm() {
        return document.getElementById(this.formId);
      }

      get variantPicker() {
        return document.getElementById(`variant-picker-${this.dataset.section}`);
      }

      connectedCallback() {
        this._buyButtonPast = false;
        this._footerVisible = false;

        this._syncHeaderPosition();
        this._observeBuyButton();
        this._observeFooter();
        this._listenForVariants();
        this._bindActions();

        this._headerWatcher = new MutationObserver(() => this._syncHeaderPosition());
        const hdr = document.querySelector('.section-header');
        if (hdr) {
          this._headerWatcher.observe(hdr, { attributes: true, attributeFilter: ['class'] });
        }
      }

      disconnectedCallback() {
        this._scrollObserver?.disconnect();
        this._footerObserver?.disconnect();
        this._variantUnsub?.();
        this._headerWatcher?.disconnect();
      }

      _updateVisibility() {
        this.hidden = !this._buyButtonPast || this._footerVisible;
      }

      _syncHeaderPosition() {
        const hdr = document.querySelector('.section-header');
        const isSticky = hdr?.classList.contains('shopify-section-header-sticky');
        const isHidden = hdr?.classList.contains('shopify-section-header-hidden');
        const hasAnimate = hdr?.classList.contains('animate');

        const offset = isSticky && !isHidden
          ? parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10)
          : 0;

        this.style.transition = hasAnimate
          ? 'opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease, top 0.15s ease-out'
          : 'opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease';

        this.style.setProperty('--sticky-atc-offset', `${offset}px`);
      }

      _observeBuyButton() {
        const form = this.mainForm;
        const wrapper = form?.closest('product-info') || form;
        if (!wrapper) return;

        const target = wrapper.querySelector('.product-form__submit')
          || wrapper.querySelector('[type="submit"]')
          || wrapper;

        this._scrollObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Leiste immer, sobald der normale Knopf nicht im Bild ist:
              // oben weggescrollt ODER noch unterhalb des Bildschirms.
              this._buyButtonPast = entry.intersectionRatio === 0;
              this._updateVisibility();
            });
          },
          { threshold: 0 }
        );

        this._scrollObserver.observe(target);


        const initialCheck = () => {
          const rect = target.getBoundingClientRect();
          this._buyButtonPast = rect.bottom < 0 || rect.top > window.innerHeight;
          this._updateVisibility();
        };
        if (document.readyState === 'complete') {
          requestAnimationFrame(initialCheck);
        } else {
          window.addEventListener('load', () => requestAnimationFrame(initialCheck), { once: true });
        }
      }

      _observeFooter() {
        const footer = document.querySelector('.footer, footer, [id*="footer"]');
        if (!footer) return;

        this._footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {

              this._footerVisible = entry.isIntersecting;
              this._updateVisibility();
            });
          },
          { threshold: 0 }
        );

        this._footerObserver.observe(footer);
      }

      _listenForVariants() {
        if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const sid = this.dataset.section;
          if (!sid || (data.sectionId && data.sectionId !== sid)) return;

          const v = data.variant;
          this._refreshPrice(v);
          this._refreshButton(v);
          this._refreshImage(v);
          this._pullMainSelections();
        });
      }

      _refreshPrice(variant) {
        const wrap = this.querySelector('.sticky-atc__cost .price');
        if (!wrap || !variant) return;

        const fmt = (cents) => {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
          return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
        };

        // Wenn subscription-only modus aktiv UND Variante hat selling_plan_allocations,
        // nimm den Subscription-Preis statt dem Normalpreis.
        let displayPrice = variant.price;
        let comparePrice = variant.compare_at_price;
        const forceSub = this.dataset.subscriptionOnly === 'true';
        const hasAlloc = variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0;
        if (forceSub && hasAlloc) {
          displayPrice = variant.selling_plan_allocations[0].price;
          comparePrice = (variant.compare_at_price && variant.compare_at_price > 0)
            ? variant.compare_at_price
            : variant.price;
        }

        const onSale = comparePrice && comparePrice > displayPrice;
        wrap.classList.toggle('price--on-sale', onSale);

        const regPrice = wrap.querySelector('.price__regular .price-item--regular');
        if (regPrice) regPrice.textContent = fmt(displayPrice);

        const saleCompare = wrap.querySelector('.price__sale .price-item--regular');
        if (saleCompare) saleCompare.textContent = onSale ? fmt(comparePrice) : '';

        const salePrice = wrap.querySelector('.price-item--sale');
        if (salePrice) salePrice.textContent = fmt(displayPrice);
      }

      _refreshButton(variant) {
        const btn = this.querySelector('.sticky-atc__submit');
        if (!btn) return;

        const label = btn.querySelector('.sticky-atc__label') || btn.querySelector('span');
        const addLabel = btn.dataset.addLabel || 'Add to cart';
        const soldLabel = btn.dataset.soldLabel || 'Sold out';

        if (!variant) {
          btn.disabled = true;
          if (label) label.textContent = 'Unavailable';
        } else if (!variant.available) {
          btn.disabled = true;
          if (label) label.textContent = soldLabel;
        } else {
          btn.disabled = false;
          if (label) label.textContent = addLabel;
        }
      }

      _refreshImage(variant) {
        const img = this.querySelector('.sticky-atc__media-img');
        if (!img || !variant?.featured_image?.src) return;
        img.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_110x$1');
        img.srcset = '';
      }


      _pullMainSelections() {
        const picker = this.variantPicker;
        if (!picker) return;

        this.querySelectorAll('select[data-option-position]').forEach((localSel) => {
          const pos = localSel.dataset.optionPosition;
          let currentValueId = null;


          const checkedRadio = picker.querySelector(
            `input[type="radio"][data-option-position="${pos}"]:checked`
          );
          if (checkedRadio) {
            currentValueId = checkedRadio.dataset.optionValueId;
          }


          if (!currentValueId) {
            const hiddenInput = picker.querySelector(
              `input[type="hidden"][data-option-position="${pos}"][data-option-value-id]`
            );
            if (hiddenInput) {
              currentValueId = hiddenInput.dataset.optionValueId || hiddenInput.value;
            }
          }

          if (currentValueId && localSel.value !== currentValueId) {
            localSel.value = currentValueId;


            const comboBox = localSel.closest('combo-box');
            if (comboBox) {
              comboBox.selectedValue = currentValueId;
              const toggleBtn = comboBox._toggleButton;
              if (toggleBtn) {
                const display = toggleBtn.querySelector('.select__selected-value');
                const selectedOpt = localSel.options[localSel.selectedIndex];
                if (display && selectedOpt) {

                  const swatch = display.querySelector('.select__color-swatch');
                  if (swatch) {
                    const textNode = Array.from(display.childNodes).find((n) => n.nodeType === Node.TEXT_NODE);
                    if (textNode) textNode.textContent = ` ${selectedOpt.textContent.trim()}`;
                  } else {
                    display.textContent = selectedOpt.textContent.trim();
                  }
                }
              }
            }
          }
        });
      }


      _pushToMainPicker(optionPosition, valueId) {
        const picker = this.variantPicker;
        if (!picker) return;



        const scrollY = window.scrollY;
        const restoreScroll = () => requestAnimationFrame(() => window.scrollTo(0, scrollY));




        const radio = picker.querySelector(
          `input[type="radio"][data-option-position="${optionPosition}"][data-option-value-id="${valueId}"]`
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          restoreScroll();
          return;
        }



        const hiddenInput = picker.querySelector(
          `input[type="hidden"][data-option-position="${optionPosition}"]`
        );
        if (hiddenInput) {
          const comboBox = hiddenInput.closest('combo-box');
          if (comboBox) {
            const optionBtn = comboBox.querySelector(`[role="option"][value="${valueId}"]`);
            if (optionBtn) {
              comboBox._onOptionClick(optionBtn);
              restoreScroll();
              return;
            }
          }

          hiddenInput.value = valueId;
          hiddenInput.dataset.optionValueId = valueId;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
          restoreScroll();
        }
      }

      _bindActions() {

        this.addEventListener('change', (e) => {
          const sel = e.target.closest('select[data-option-position]');
          if (!sel) return;
          this._pushToMainPicker(sel.dataset.optionPosition, sel.value);
        });


        const submitBtn = this.querySelector('.sticky-atc__submit');
        const spinner = submitBtn?.querySelector('.loading__spinner');

        submitBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          if (submitBtn.getAttribute('aria-disabled') === 'true' || submitBtn.disabled) return;


          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('loading');
          spinner?.classList.remove('hidden');

          this.mainForm?.querySelector('[type="submit"]')?.click();
        });


        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this._clearLoading());
          subscribe(PUB_SUB_EVENTS.cartError, () => this._clearLoading());
        }
      }

      _clearLoading() {
        const btn = this.querySelector('.sticky-atc__submit');
        if (!btn) return;
        const spinner = btn.querySelector('.loading__spinner');

        setTimeout(() => {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }, 500);
      }
    }
  );
}

function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());

class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {

      if (event.target.closest('volume-discounts')) return;
      if (event.target.closest('.bundle-subscription-toggle')) return;

      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });


    this.querySelectorAll('a[data-option-value-id]').forEach((link) => {
      link.addEventListener('click', (event) => {

      });
    });

    this.initBundleSubscriptionToggle();
    this.initBundlePreselection();
  }

  initBundlePreselection() {
    const bundle = this.querySelector('.bundle[data-preselected]');
    if (!bundle) return;

    const sectionId = this.getAttribute('data-section');
    const key = `bundle-preselected-${sectionId}`;
    if (window[key]) return;
    window[key] = true;

    const index = parseInt(bundle.dataset.preselected);
    if (!index) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;

    const radios = bundle.querySelectorAll('input[type="radio"]');
    const target = radios[index - 1];
    if (target && !target.checked) {
      target.checked = true;
      // Fire change so the variant-picker/form actually switches to the preselected
      // variant (otherwise the form keeps the default variant -> wrong item in cart).
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  initBundleSubscriptionToggle() {
    const toggle = this.querySelector('.bundle-subscription-toggle__input');
    if (!toggle) return;

    const bundle = this.querySelector('.bundle');
    if (!bundle) return;

    const sectionId = this.getAttribute('data-section');
    const storageKey = `bundle-sub-${sectionId}`;

    const savedState = sessionStorage.getItem(storageKey);
    if (savedState !== null) {
      const isChecked = savedState === 'true';
      toggle.checked = isChecked;
      bundle.classList.toggle('subscription-active', isChecked);
    }

    toggle.addEventListener('change', () => {
      bundle.classList.toggle('subscription-active', toggle.checked);
      sessionStorage.setItem(storageKey, toggle.checked);
    });
  }

  updateSelectionMetadata({ target }) {
    const { tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const previousSelected = Array.from(target.options).find((option) => option.getAttribute('selected'));
      if (previousSelected) previousSelected.removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
    } else if (tagName === 'INPUT' && target.type === 'radio') {

      const container = target.closest('.product-form__input');
      const selectedValueDisplay = container?.querySelector('[data-selected-value]');
      if (selectedValueDisplay) {

        const label = container.querySelector(`label[for="${target.id}"]`);
        const visibleText =
          label?.querySelector('.visually-hidden')?.textContent ||
          target.value;
        selectedValueDisplay.textContent = visibleText.trim();
      }
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {

    const selected = [];


    this.querySelectorAll('input[type="radio"]:checked[data-option-value-id]').forEach((input) => {
      selected.push(input.dataset.optionValueId);
    });


    this.querySelectorAll('input[type="hidden"][data-option-position][data-option-value-id]').forEach((input) => {
      selected.push(input.dataset.optionValueId);
    });


    this.querySelectorAll('select[data-option-position]').forEach((select) => {
      const selectedOption = select.selectedOptions[0];
      if (selectedOption?.dataset?.optionValueId) {
        selected.push(selectedOption.dataset.optionValueId);
      }
    });

    return selected;
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}

class BuyOnceInfo extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
  }

  connectedCallback() {
    this.button = this.querySelector('.buy-once-info__button');
    if (!this.button) return;
    this.button.addEventListener('click', this.handleClick.bind(this));

    // Der Block folgt der Auswahl oben BEWUSST nicht: einzeln gibt es nur das
    // kleinste Pack. Wer die Abo-Groessen durchklickt, soll hier weiter
    // denselben Preis sehen. Variante und Preis stehen fest im Liquid.
  }

  async handleClick(event) {
    event.preventDefault();
    if (this.loading) return;

    const variantId = this.dataset.variantId;
    if (!variantId) return;
    if (this.dataset.unavailable === 'true') return;

    this.loading = true;
    this.classList.add('is-loading');
    this.button.setAttribute('aria-busy', 'true');

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!addResponse.ok) {
        const data = await addResponse.json().catch(() => ({}));
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'buy-once-info',
          productVariantId: variantId,
          errors: data.errors || data.description,
          message: data.message,
        });
        return;
      }

      const data = await addResponse.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'buy-once-info',
        productVariantId: variantId,
        cartData: data,
      });

      await this.refreshCartDrawer();
    } catch (error) {
      console.error('BuyOnceInfo add to cart error:', error);
    } finally {
      this.loading = false;
      this.classList.remove('is-loading');
      this.button.removeAttribute('aria-busy');
    }
  }

  async refreshCartDrawer() {
    const cart = document.querySelector('cart-drawer');
    if (!cart) return;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const [drawerRes, iconRes] = await Promise.all([
        fetch(`${root}cart?section_id=cart-drawer`),
        fetch(`${root}cart?section_id=cart-icon-bubble`),
      ]);

      const drawerHtml = await drawerRes.text();
      const iconHtml = await iconRes.text();

      const cartDrawerEl = document.querySelector('#CartDrawer');
      if (cartDrawerEl) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const source = doc.querySelector('#CartDrawer');
        if (source) {
          if (cart.classList.contains('active') && document.querySelector('#CartDrawer-Form .js-contents')) {
            const newItems = doc.querySelector('.js-contents');
            const curItems = document.querySelector('#CartDrawer-Form .js-contents');
            if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

            const newFooter = doc.querySelector('.drawer__footer');
            const curFooter = document.querySelector('#CartDrawer .drawer__footer');
            if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;

            const newHeading = doc.querySelector('.drawer__heading');
            const curHeading = document.querySelector('#CartDrawer .drawer__heading');
            if (newHeading && curHeading) curHeading.innerHTML = newHeading.innerHTML;

            const drawerInner = cart.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');
          } else {
            cartDrawerEl.innerHTML = source.innerHTML;
          }
        }
      }

      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble) {
        const doc = new DOMParser().parseFromString(iconHtml, 'text/html');
        const source = doc.querySelector('.shopify-section');
        if (source) {
          iconBubble.innerHTML = source.innerHTML;
        }
      }
    } catch (error) {
      console.error('BuyOnceInfo cart refresh error:', error);
    }

    cart.classList.remove('is-empty');
    cart.offsetHeight;
    const overlay = cart.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', cart.close.bind(cart));
    cart.setActiveElement(this.button);
    cart.open();
  }
}

if (!customElements.get('buy-once-info')) {
  customElements.define('buy-once-info', BuyOnceInfo);
}

if (!customElements.get('native-video')) {
  class NativeVideo extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.hasLoaded = false;

      if (this.autoPlay) {
        this.observeVisibility();
      } else {
        const playBtn = this.querySelector('.video-wrapper__play-button');
        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.play();
          });
        }

        this.addEventListener('click', () => {
          if (!this.hasLoaded) return;
          const video = this.querySelector('video');
          if (video && !video.paused) {
            video.pause();
            this._showPlayOverlay();
          }
        });
      }
    }

    get autoPlay() {
      return this.hasAttribute('autoplay');
    }

    play() {
      if (!this.hasLoaded) {
        this._loadVideo();
      }
      const video = this.querySelector('video');
      if (video) {
        if (!video._pauseOverlayBound) {
          video._pauseOverlayBound = true;
          video.addEventListener('pause', () => this._showPlayOverlay());
          video.addEventListener('ended', () => this._showPlayOverlay());
        }
        video.play();
      }

      const poster = this.querySelector('.video-wrapper__poster');
      if (poster) poster.style.display = 'none';

      this._hidePlayOverlay();
    }


    pause() {
      const video = this.querySelector('video');
      if (video && !video.paused) video.pause();
    }

    _showPlayOverlay() {
      if (!this._overlay) {
        const originalBtn = this.querySelector('.video-wrapper__play-button');
        this._overlay = document.createElement('div');
        this._overlay.className = 'video-wrapper__play-overlay';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'video-wrapper__play-button';
        btn.innerHTML = originalBtn ? originalBtn.innerHTML : '';
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.play();
        });
        this._overlay.appendChild(btn);
        this.appendChild(this._overlay);
      }
      this._overlay.style.display = '';
    }

    _hidePlayOverlay() {
      if (this._overlay) this._overlay.style.display = 'none';
    }

    _loadVideo() {
      if (this.hasLoaded) return;
      const template = this.querySelector('template');
      if (!template) return;

      const node = template.content.firstElementChild.cloneNode(true);
      if (this.hasAttribute('data-loop')) {
        node.loop = true;
      }
      template.replaceWith(node);
      this.hasLoaded = true;

      this.dispatchEvent(new CustomEvent('video:loaded', { bubbles: true }));
    }

    observeVisibility() {
      const loadObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasLoaded) {
              this._loadVideo();
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0, rootMargin: '200px' }
      );

      const playObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const video = this.querySelector('video');
              if (video) video.play();
              const poster = this.querySelector('.video-wrapper__poster');
              if (poster) poster.style.display = 'none';
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0.5 }
      );

      loadObserver.observe(this);
      playObserver.observe(this);
    }
  }

  customElements.define('native-video', NativeVideo);
}

if (!customElements.get('external-video')) {
  class ExternalVideo extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.hasLoaded = false;

      if (this.autoPlay) {
        this._setupVisibility();
      } else {
        const playBtn = this.querySelector('.video-wrapper__play-button');
        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.play();
          });
        }

        this.addEventListener('click', () => {
          if (!this.hasLoaded) return;
          this._pausePlayer();
          this._showPlayOverlay();
        });
      }
    }

    get autoPlay() {
      return this.hasAttribute('autoplay');
    }

    get provider() {
      return this.getAttribute('provider');
    }

    async play() {
      if (!this.hasLoaded) {
        await this._loadPlayer();
      }

      const poster = this.querySelector('.video-wrapper__poster');
      if (poster) poster.style.display = 'none';

      this._hidePlayOverlay();

      if (this.provider === 'youtube') {
        setTimeout(() => {
          const iframe = this.querySelector('iframe');
          if (iframe) {
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'playVideo', args: '' }),
              '*'
            );
          }
        }, 150);
      } else if (this.provider === 'vimeo') {
        const iframe = this.querySelector('iframe');
        if (iframe) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        }
      }
    }


    pause() {
      this._pausePlayer();
      this._showPlayOverlay();
    }

    _pausePlayer() {
      if (!this.hasLoaded) return;

      if (this.provider === 'youtube') {
        const iframe = this.querySelector('iframe');
        if (iframe) {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
            '*'
          );
        }
      } else if (this.provider === 'vimeo') {
        const iframe = this.querySelector('iframe');
        if (iframe) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        }
      }
    }

    _showPlayOverlay() {
      if (!this._overlay) {
        const originalBtn = this.querySelector('.video-wrapper__play-button');
        this._overlay = document.createElement('div');
        this._overlay.className = 'video-wrapper__play-overlay';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'video-wrapper__play-button';
        btn.innerHTML = originalBtn ? originalBtn.innerHTML : '';
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.play();
        });
        this._overlay.appendChild(btn);
        this.appendChild(this._overlay);
      }
      this._overlay.style.display = '';
    }

    _hidePlayOverlay() {
      if (this._overlay) this._overlay.style.display = 'none';
    }

    _loadPlayer() {
      if (this._loadPromise) return this._loadPromise;

      return (this._loadPromise = new Promise((resolve) => {
        const template = this.querySelector('template');
        if (!template) return resolve();

        const node = template.content.firstElementChild.cloneNode(true);

        node.onload = () => {
          this.hasLoaded = true;
          resolve();
        };

        template.replaceWith(node);
      }));
    }

    _setupVisibility() {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play();
              obs.unobserve(this);
            }
          });
        },
        { threshold: 0, rootMargin: '300px' }
      );
      observer.observe(this);
    }
  }

  customElements.define('external-video', ExternalVideo);
}

async function initializeQuantityBreaks() {
  const allQuantityBreaksElements = document.querySelectorAll('volume-discounts');

  if (allQuantityBreaksElements.length === 0) return;

  for (const quantityBreaksElement of allQuantityBreaksElements) {
    await initializeSingleQuantityBreak(quantityBreaksElement);
  }
}

async function initializeSingleQuantityBreak(quantityBreaksElement) {
  if (quantityBreaksElement.hasAttribute('data-qb-initialized')) return;
  quantityBreaksElement.setAttribute('data-qb-initialized', 'true');

  const sectionId = quantityBreaksElement.dataset.section;

  let _cachedVariants = null;
  let _variantenAnfrage = null;
  let _frischeSections = null;
  async function getProductVariants() {
    if (_cachedVariants) return _cachedVariants;
    const handle = quantityBreaksElement?.dataset.handle;
    if (!handle) return [];
    if (!_variantenAnfrage) {
      _variantenAnfrage = fetch(`/products/${handle}.js`)
        .then((response) => {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then((productData) => {
          _cachedVariants = productData?.variants || [];
          return _cachedVariants;
        })
        .catch((error) => {
          _variantenAnfrage = null;
          throw error;
        });
    }
    return _variantenAnfrage;
  }

  function mitSections(daten) {
    return Object.assign({}, daten, { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname });
  }

  async function merkeSections(antwort) {
    const daten = await antwort.clone().json().catch(() => null);
    _frischeSections = daten && daten.sections ? daten.sections : null;
  }

  function getMasterSelectForCurrentLabel() {
    // Die Seite rendert den Mengen-Block zweimal: einmal im Hauptbereich,
    // einmal in der Sticky-Leiste. Beide Radiogruppen heissen "quantity" und
    // gehoeren zum selben Formular, sind also EINE Gruppe. Waehlt der Kunde
    // im einen Block, verliert der andere seine Auswahl. Wer dann nur im
    // eigenen Block sucht, findet nichts und sperrt den Kaufknopf.
    const activeRadio =
      quantityBreaksElement.querySelector("input[name='quantity']:checked") ||
      document.querySelector("input[name='quantity']:checked");
    if (!activeRadio) return null;

    const radioId = activeRadio.id;
    const quantityMatch = radioId.match(/quantity(\d+)/);
    if (!quantityMatch) return null;

    const quantityNumber = quantityMatch[1];
    return document.getElementById(`master-select-${sectionId}-q${quantityNumber}`);
  }

  function updateMasterSelectFromSelects(selectorItem) {
    if (!selectorItem) return;
    const currentMasterSelect = getMasterSelectForCurrentLabel();
    if (!currentMasterSelect) return;

    const selectElements = selectorItem.querySelectorAll('.qb-select');
    const selectedValues = Array.from(selectElements).map(select => select.value);

    const matchingOption = Array.from(currentMasterSelect.options).find(option =>
      selectedValues.every(val => option.textContent.includes(val))
    );

    if (!matchingOption) return;

    currentMasterSelect.value = matchingOption.value;
    const selectedMediaId = matchingOption.getAttribute('data-media-id');

    // Main product page: client-side gallery filtering
    const mediaGallery = document.querySelector(`#MainProduct-${sectionId} media-gallery`);
    if (mediaGallery?.filterByVariant) {
      mediaGallery.filterByVariant(selectedValues, selectedMediaId);
    }

    // Product drawer context: update thumb image
    updateDrawerThumb(matchingOption.value);
  }

  function updateDrawerThumb(variantId) {
    const drawerBody = quantityBreaksElement.closest('.product-drawer__body');
    if (!drawerBody) return;
    const thumbImg = drawerBody.querySelector('.product-drawer__thumb-img');
    if (!thumbImg) return;

    const imageDataEl = drawerBody.querySelector('[data-drawer-variant-images]');
    if (imageDataEl) {
      try {
        const variantImages = JSON.parse(imageDataEl.textContent);
        const imgUrl = variantImages[variantId];
        if (imgUrl) {
          thumbImg.src = imgUrl;
          thumbImg.srcset = '';
        }
      } catch (e) {}
    } else {
      const handle = quantityBreaksElement.dataset.handle;
      if (!handle) return;
      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          const variant = product.variants.find((v) => v.id === parseInt(variantId));
          if (variant && variant.featured_image) {
            thumbImg.src = variant.featured_image.src;
            thumbImg.srcset = '';
          }
        })
        .catch(() => {});
    }
  }

  function findSubmitButton() {

    let btn = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!btn) {
      const productInfo = document.getElementById(`MainProduct-${sectionId}`);
      if (productInfo) {
        btn = productInfo.querySelector('button[type="submit"][name="add"]');
      }
    }
    if (!btn) {
      btn = document.querySelector(`#MainProduct-${sectionId} product-form button[type="submit"]`);
    }
    return btn;
  }

  function setButtonStatus(isAvailable, text = null) {
    const addToCartButton = findSubmitButton();
    if (!addToCartButton) return;

    const buttonText = addToCartButton.querySelector('span');
    // Wie oben: den Pfeil neben der Schrift beim Beschriften behalten.
    const beschriften = (t) => {
      if (!buttonText || !t) return;
      const pfeil = buttonText.querySelector('.btn-arrow');
      buttonText.textContent = t;
      if (pfeil) buttonText.appendChild(pfeil);
    };

    if (isAvailable) {
      addToCartButton.disabled = false;
      beschriften(text);
    } else {
      addToCartButton.disabled = true;
      beschriften(text);
    }
  }

  function checkAvailability() {
    // Die Seite rendert den Mengen-Block zweimal: einmal im Hauptbereich,
    // einmal in der Sticky-Leiste. Beide Radiogruppen heissen "quantity" und
    // gehoeren zum selben Formular, sind also EINE Gruppe. Waehlt der Kunde
    // im einen Block, verliert der andere seine Auswahl. Wer dann nur im
    // eigenen Block sucht, findet nichts und sperrt den Kaufknopf.
    const activeRadio =
      quantityBreaksElement.querySelector("input[name='quantity']:checked") ||
      document.querySelector("input[name='quantity']:checked");
    if (!activeRadio) {
      setButtonStatus(false, 'Select quantity');
      return;
    }

    const activeQtyBreak = quantityBreaksElement.querySelector(`label[for='${activeRadio.id}']`);
    if (!activeQtyBreak) {
      setButtonStatus(false);
      return;
    }

    if (activeQtyBreak.classList.contains('quantity-break--sold-out')) {
      setButtonStatus(false, 'Sold out');
      return;
    }

    const variantSelectors = activeQtyBreak.querySelectorAll('.quantity-break__selector-item');

    if (variantSelectors.length === 0) {
      setButtonStatus(true);
      return;
    }

    let hasSoldOutVariant = false;
    variantSelectors.forEach(selector => {
      const comboBoxes = selector.querySelectorAll('combo-box');
      comboBoxes.forEach(cb => {
        const selectedBtn = cb.querySelector('[role="option"][aria-selected="true"]');
        if (selectedBtn && selectedBtn.classList.contains('is-disabled')) {
          hasSoldOutVariant = true;
        }
      });
    });

    if (hasSoldOutVariant) {
      setButtonStatus(false, 'Sold out');
    } else {
      setButtonStatus(true);
    }
  }

  const isSubscriptionOnly = quantityBreaksElement.dataset.subscriptionOnly === 'true';

  function toggleSubscriptionElements() {
    if (isSubscriptionOnly) {
      quantityBreaksElement.classList.add('subscription-active');
      updateFreeItemsVisibility();
      return;
    }

    const subscriptionToggle = quantityBreaksElement.closest(`#MainProduct-${sectionId}`)?.querySelector('input[name="shipping-switch-new-product"]')
      || document.querySelector(`input[id*="shipping-switch-new-product"]`);
    const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;

    if (isSubscriptionEnabled) {
      quantityBreaksElement.classList.add('subscription-active');
    } else {
      quantityBreaksElement.classList.remove('subscription-active');
    }

    updateFreeItemsVisibility();
  }

  function initializeSubscriptionElements() {
    const hideFreeItems = quantityBreaksElement.dataset.hideFreeItems === 'true';

    if (isSubscriptionOnly) {
      quantityBreaksElement.classList.add('subscription-active');
    } else {
      const subscriptionToggle = quantityBreaksElement.closest(`#MainProduct-${sectionId}`)?.querySelector('input[name="shipping-switch-new-product"]')
        || document.querySelector(`input[id*="shipping-switch-new-product"]`);
      const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;

      if (isSubscriptionEnabled) {
        quantityBreaksElement.classList.add('subscription-active');
      } else {
        quantityBreaksElement.classList.remove('subscription-active');
      }
    }

    if (hideFreeItems) {
      quantityBreaksElement.classList.add('hide-free-items-without-subscription');
    }
  }

  function shouldShowFreeItems() {
    if (isSubscriptionOnly) return true;
    const subscriptionToggle = quantityBreaksElement.closest(`#MainProduct-${sectionId}`)?.querySelector('input[name="shipping-switch-new-product"]')
      || document.querySelector(`input[id*="shipping-switch-new-product"]`);
    const hideFreeItems = quantityBreaksElement.dataset.hideFreeItems === 'true';
    const isSubscriptionEnabled = subscriptionToggle ? subscriptionToggle.checked : false;
    return !hideFreeItems || (hideFreeItems && isSubscriptionEnabled);
  }

  function updateFreeItemsVisibility() {
    const freeSelectors = quantityBreaksElement.querySelectorAll('.quantity-break__selector-item[data-is-free="true"]');
    freeSelectors.forEach(selector => {
      selector.classList.remove('force-hidden');
    });
  }


  initializeSubscriptionElements();
  updateFreeItemsVisibility();

  setTimeout(() => {
    checkAvailability();
  }, 100);


  const subscriptionToggle = quantityBreaksElement.closest(`#MainProduct-${sectionId}`)?.querySelector('input[name="shipping-switch-new-product"]')
    || document.querySelector(`input[id*="shipping-switch-new-product"]`);
  if (subscriptionToggle) {
    subscriptionToggle.addEventListener('change', () => {
      toggleSubscriptionElements();
      updateFreeItemsVisibility();
    });
  }


  const quantityRadios = quantityBreaksElement.querySelectorAll('input[name="quantity"]');
  quantityRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      checkAvailability();
    });
  });


  const selectElements = quantityBreaksElement.querySelectorAll('.qb-select');

  selectElements.forEach(select => {
    select.addEventListener('change', function() {

      const selectorItem = this.closest('.quantity-break__selector-item');

      updateMasterSelectFromSelects(selectorItem);
      checkAvailability();
    });
  });




  function initializeAddToCart() {
    const addToCartButton = findSubmitButton();
    if (!addToCartButton) return;

    const initFlag = `data-volume-discounts-initialized-${sectionId}`;
    if (addToCartButton.hasAttribute(initFlag)) return;

    addToCartButton.setAttribute(initFlag, 'true');


    addToCartButton.addEventListener('click', async function(event) {

      // Die Seite rendert den Mengen-Block zweimal: einmal im Hauptbereich,
    // einmal in der Sticky-Leiste. Beide Radiogruppen heissen "quantity" und
    // gehoeren zum selben Formular, sind also EINE Gruppe. Waehlt der Kunde
    // im einen Block, verliert der andere seine Auswahl. Wer dann nur im
    // eigenen Block sucht, findet nichts und sperrt den Kaufknopf.
    const activeRadio =
      quantityBreaksElement.querySelector("input[name='quantity']:checked") ||
      document.querySelector("input[name='quantity']:checked");
      if (!activeRadio) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      toggleLoader(true);

      const activeQtyBreak = quantityBreaksElement.querySelector(`label[for='${activeRadio.id}']`);
      if (!activeQtyBreak || activeQtyBreak.classList.contains('quantity-break--sold-out')) {
        toggleLoader(false);
        return;
      }

      const variantSelectors = activeQtyBreak.querySelectorAll('.quantity-break__selector-item');


      let hasSoldOutVariant = false;
      variantSelectors.forEach(selector => {
        const comboBoxes = selector.querySelectorAll('combo-box');
        comboBoxes.forEach(cb => {
          const selectedBtn = cb.querySelector('[role="option"][aria-selected="true"]');
          if (selectedBtn && selectedBtn.classList.contains('is-disabled')) {
            hasSoldOutVariant = true;
          }
        });
      });

      if (hasSoldOutVariant) {
        toggleLoader(false);
        return;
      }

      let totalQuantity = parseInt(activeQtyBreak.dataset.quantity, 10) || 1;


      let productVariants = [];
      try {
        productVariants = await getProductVariants();
      } catch (error) {
        toggleLoader(false);
        return;
      }


      if (variantSelectors.length === 0) {
        let variantId = null;

        // Erst das Master-Select der Mengenoption: dort steht die Variante,
        // die diese Option verkauft (bei KYLA immer das 1 Pack). Das
        // Formularfeld traegt nur die zufaellig vorgewaehlte Variante.
        // Nur wenn die Option eine feste Variante verkauft. Sonst gilt die
        // Variante aus der Groessenwahl darueber, also das Formularfeld.
        const currentMasterSelect = getMasterSelectForCurrentLabel();
        const productFormInput = document.querySelector(`#MainProduct-${sectionId} product-form input[name="id"]`)
          || document.querySelector(`#product-form-${sectionId} input[name="id"]`);

        const kitWert = activeQtyBreak.dataset.kit;
        const kitPosition = parseInt(activeQtyBreak.dataset.kitPosition, 10);
        if (kitWert && kitPosition && productFormInput && productFormInput.value) {
          const kitBasis = productVariants.find((v) => v.id === parseInt(productFormInput.value));
          const kitTreffer = kitBasis && productVariants.find((v) => v.options.every((wert, stelle) => (stelle === kitPosition - 1 ? wert === kitWert : wert === kitBasis.options[stelle])));
          if (kitTreffer) variantId = kitTreffer.id;
        }

        if (!variantId && currentMasterSelect && currentMasterSelect.value && currentMasterSelect.dataset.fest === 'true') {
          variantId = parseInt(currentMasterSelect.value);
        }

        if (!variantId && productFormInput && productFormInput.value) {
          variantId = parseInt(productFormInput.value);
        }

        if (!variantId) {
          if (productVariants.length === 1) {
            variantId = productVariants[0].id;
          } else if (productVariants.length > 0) {
            const availableVariant = productVariants.find(v => v.available);
            variantId = availableVariant ? availableVariant.id : productVariants[0].id;
          }
        }

        if (variantId) {
          // Block „App-Auswahl“ angehakt: Kit und Membership zusammen in einem
          // Aufruf, sonst der bisherige Einzelaufruf.
          const appAddon = (quantityBreaksElement.closest('.shopify-section') || document).querySelector('[data-app-addon]');
          const appAn = appAddon && appAddon.dataset.variantId && appAddon.querySelector('input[value="1"]:checked');
          let success = false;
          if (appAn) {
            const appItem = { id: parseInt(appAddon.dataset.variantId, 10), quantity: 1 };
            if (appAddon.dataset.planId) appItem.selling_plan = parseInt(appAddon.dataset.planId, 10);
            try {
              const antwort = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(mitSections({ items: [{ id: variantId, quantity: totalQuantity }, appItem] }))
              });
              success = antwort.ok;
              if (antwort.ok) await merkeSections(antwort);
              if (!antwort.ok) {
                const fehler = await antwort.json().catch(() => ({}));
                console.error('cart/add', fehler.description || fehler.message || antwort.status);
              }
            } catch (e) {}
          } else {
            success = await addToCart(variantId, totalQuantity);
          }
          if (success) await updateCart();
        }

        toggleLoader(false);
        return;
      }


      const variantGroups = [];
      variantSelectors.forEach(group => {
        const selects = group.querySelectorAll('.qb-select');
        const selectedOptions = Array.from(selects).map(select => select.value);
        const isFree = group.getAttribute('data-is-free') === 'true';
        variantGroups.push({ options: selectedOptions, isFree: isFree });
      });

      let selectedVariants = [];
      variantGroups.forEach(group => {
        const foundVariant = productVariants.find(variant => {
          let variantOptions = [];
          if (variant.option1) variantOptions.push(variant.option1);
          if (variant.option2) variantOptions.push(variant.option2);
          if (variant.option3) variantOptions.push(variant.option3);
          if (variantOptions.length === 0 && variant.public_title) {
            variantOptions = variant.public_title.split(' / ');
          }
          return group.options.every(option => variantOptions.includes(option));
        });

        if (foundVariant) {
          selectedVariants.push({ variant: foundVariant, isFree: group.isFree });
        }
      });

      if (selectedVariants.length === 0) {
        toggleLoader(false);
        return;
      }


      const variantMap = new Map();
      selectedVariants.forEach((item) => {
        const variantId = item.variant.id;
        if (variantMap.has(variantId)) {
          const existing = variantMap.get(variantId);
          variantMap.set(variantId, {
            paidQuantity: existing.paidQuantity + (item.isFree ? 0 : 1),
            totalQuantity: existing.totalQuantity + 1,
            variant: item.variant
          });
        } else {
          variantMap.set(variantId, {
            paidQuantity: item.isFree ? 0 : 1,
            totalQuantity: 1,
            variant: item.variant
          });
        }
      });


      const itemsBatch = [];
      const showFree = shouldShowFreeItems();

      for (const [variantId, data] of variantMap.entries()) {
        const totalQty = showFree ? data.totalQuantity : data.paidQuantity;
        if (totalQty <= 0) continue;

        const item = { id: parseInt(variantId), quantity: totalQty };

        const subscriptionToggle = quantityBreaksElement.closest(`#MainProduct-${sectionId}`)?.querySelector('input[name="shipping-switch-new-product"]')
          || document.querySelector(`input[id*="shipping-switch-new-product"]`);
        if (isSubscriptionOnly || subscriptionToggle?.checked) {
          const variantData = data.variant || productVariants.find((v) => v.id === parseInt(variantId));
          if (variantData && variantData.selling_plan_allocations && variantData.selling_plan_allocations.length > 0) {
            item.selling_plan = parseInt(variantData.selling_plan_allocations[0].selling_plan_id);
          }
        }

        itemsBatch.push(item);
      }

      // Block „App-Auswahl“: mit App geht die Membership samt Abo-Plan im
      // selben Aufruf mit, damit Ball und Abo zusammen im Warenkorb landen.
      const appAddon = (quantityBreaksElement.closest('.shopify-section') || document).querySelector('[data-app-addon]');
      if (itemsBatch.length > 0 && appAddon && appAddon.dataset.variantId && appAddon.querySelector('input[value="1"]:checked')) {
        const appItem = { id: parseInt(appAddon.dataset.variantId, 10), quantity: 1 };
        if (appAddon.dataset.planId) appItem.selling_plan = parseInt(appAddon.dataset.planId, 10);
        itemsBatch.push(appItem);
      }

      if (itemsBatch.length > 0) {
        try {
          const antwort = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mitSections({ items: itemsBatch }))
          });
          if (antwort.ok) await merkeSections(antwort);
          if (!antwort.ok) {
            const fehler = await antwort.json().catch(() => ({}));
            console.error('cart/add', fehler.description || fehler.message || antwort.status);
          }
        } catch (e) {}
      }

      await updateCart();
      toggleLoader(false);
    }, { capture: true });
  }

  async function addToCartFree(variantId, quantity) {
    _frischeSections = null;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: { '_free_item': 'true' }
        })
      });
      return response && response.ok;
    } catch (error) {
      return false;
    }
  }

  async function addToCart(variantId, quantity) {
    try {
      const subscriptionToggle = quantityBreaksElement.closest(`#MainProduct-${sectionId}`)?.querySelector('input[name="shipping-switch-new-product"]')
        || document.querySelector(`input[id*="shipping-switch-new-product"]`);
      const isSubscriptionEnabled = isSubscriptionOnly || (subscriptionToggle ? subscriptionToggle.checked : false);

      let cartItemData = { id: parseInt(variantId), quantity };

      if (isSubscriptionEnabled) {
        // Der Plan haengt an der gewaehlten Menge, nicht an der Variante:
        // zwei Packs laufen alle zwei Monate, drei alle drei. Er steht am
        // Master-Select der Mengenoption. Ohne ihn der erste Plan der Variante.
        const gewaehlt = getMasterSelectForCurrentLabel();
        const planAusOption = gewaehlt && gewaehlt.selectedOptions[0]
          ? parseInt(gewaehlt.selectedOptions[0].dataset.sellingPlanId, 10)
          : 0;
        if (planAusOption) {
          cartItemData.selling_plan = planAusOption;
        } else {
          try {
            const variants = await getProductVariants();
            const variant = variants.find((v) => v.id === parseInt(variantId));
            if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
              cartItemData.selling_plan = parseInt(variant.selling_plan_allocations[0].selling_plan_id);
            }
          } catch (e) {}
        }
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(mitSections(cartItemData))
      });

      if (response && response.ok) await merkeSections(response);
      return response && response.ok;
    } catch (error) {
      return false;
    }
  }

  async function updateCart() {
    const cart = document.querySelector('cart-drawer');
    if (!cart) return;


    try {
      let drawerHtml;
      let iconHtml;
      if (_frischeSections && _frischeSections['cart-drawer'] && _frischeSections['cart-icon-bubble']) {
        drawerHtml = _frischeSections['cart-drawer'];
        iconHtml = _frischeSections['cart-icon-bubble'];
      } else {
        const [drawerRes, iconRes] = await Promise.all([
          fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`),
          fetch(`${window.Shopify.routes.root}cart?section_id=cart-icon-bubble`)
        ]);
        drawerHtml = await drawerRes.text();
        iconHtml = await iconRes.text();
      }
      _frischeSections = null;


      const cartDrawerEl = document.querySelector('#CartDrawer');
      if (cartDrawerEl) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const source = doc.querySelector('#CartDrawer');
        if (source) {
          if (cart.classList.contains('active') && document.querySelector('#CartDrawer-Form .js-contents')) {


            const newItems = doc.querySelector('.js-contents');
            const curItems = document.querySelector('#CartDrawer-Form .js-contents');
            if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

            const newFooter = doc.querySelector('.drawer__footer');
            const curFooter = document.querySelector('#CartDrawer .drawer__footer');
            if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;

            const newHeading = doc.querySelector('.drawer__heading');
            const curHeading = document.querySelector('#CartDrawer .drawer__heading');
            if (newHeading && curHeading) curHeading.innerHTML = newHeading.innerHTML;


            const drawerInner = cart.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');

          } else {
            cartDrawerEl.innerHTML = source.innerHTML;
          }
        }
      }


      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble) {
        const doc = new DOMParser().parseFromString(iconHtml, 'text/html');
        const source = doc.querySelector('.shopify-section');
        if (source) {
          iconBubble.innerHTML = source.innerHTML;
        }
      }
    } catch (error) {
      console.error('[VD] section fetch error:', error);
    }


    const wasSurgical = cart.classList.contains('active');
    cart.classList.remove('is-empty');
    cart.offsetHeight;
    const overlay = cart.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', cart.close.bind(cart));
    cart.open();


    if (wasSurgical) {
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((r) => r.json())
        .then((cartData) => {
          const shippingBar = cart.querySelector('free-shipping-bar');
          if (shippingBar) {
            const totalPrice = (cartData.items || [])
              .filter((i) => i.requires_shipping)
              .reduce((sum, i) => sum + i.final_line_price, 0);
            shippingBar.updateBar(totalPrice);
          }
          const recs = cart.querySelector('cart-drawer-recommendations');
          if (recs) {
            const cartIds = new Set((cartData.items || []).map((i) => i.product_id));
            if (typeof CartDrawerRecommendations !== 'undefined') {
              CartDrawerRecommendations.currentCartProductIds = cartIds;
            }
            recs.querySelectorAll('.cart-drawer__recommendation-card').forEach((card) => {
              if (cartIds.has(parseInt(card.dataset.productId))) card.remove();
            });
            if (!recs.querySelector('.cart-drawer__recommendation-card')) {
              recs.hidden = true;
            }
          }
        })
        .catch(() => {});
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
    }
  }

  function toggleLoader(isLoading) {
    const addToCartButton = findSubmitButton();
    if (!addToCartButton) return;

    const loadingSpinner = addToCartButton.querySelector('.loading__spinner');

    if (isLoading) {
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.setAttribute('aria-busy', 'true');
      addToCartButton.classList.add('loading');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');
    } else {
      addToCartButton.removeAttribute('disabled');
      addToCartButton.setAttribute('aria-busy', 'false');
      addToCartButton.classList.remove('loading');
      if (loadingSpinner) loadingSpinner.classList.add('hidden');
    }
  }


  function observeFormChanges() {
    const productForm = document.querySelector(`#MainProduct-${sectionId} product-form`);
    if (!productForm) return;

    const observer = new MutationObserver(() => {
      initializeAddToCart();
    });

    observer.observe(productForm, { childList: true, subtree: true });
  }

  getProductVariants().catch(() => {});
  initializeAddToCart();
  observeFormChanges();
}

document.addEventListener('DOMContentLoaded', function() {
  initializeQuantityBreaks();
});

if (typeof window._qbObserver === 'undefined') {
window._qbObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        const newQuantityBreaks = node.querySelectorAll ? node.querySelectorAll('volume-discounts') : [];
        if (newQuantityBreaks.length > 0 || node.tagName === 'VOLUME-DISCOUNTS') {

          setTimeout(() => {
            initializeQuantityBreaks();
          }, 100);
        }
      }
    });
  });
});

window._qbObserver.observe(document.body, {
  childList: true,
  subtree: true
});
}

document.addEventListener('animationend', (e) => {
  if (e.target.classList.contains('scroll-trigger') && e.animationName === 'slideIn') {
    e.target.style.animation = 'none';
    e.target.style.transform = 'none';
    e.target.style.opacity = '1';
  }
});
